import { message } from 'antd'
import {
  loadIsNotesRowVisible,
  loadIsPaymentPanelActionCompleteActive,
  loadIsSalePanelActive,
  loadTableDataSellTax,
  loadSaleOrderJson,
  loadSalePayments,
  loadTableDataSaleProduct,
  loadTableDataSellPromotion,
  loadIsSalePaymentProcessStart,
  loadIsPaymentPanelLoading,
  loadCurrentSalesOrderStatusID,
  loadIsRefundSale,
  loadRefundProdKeys,
  loadExchangeSale,
  loadEarnedLoyalty,
  loadStorePaymentTypes,
  loadCustomerAccountDetails,
  loadSalesOrderStatuses,
  loadAccLaybyCreditAmount,
  loadRowDataUpdated,
  loadIsDiscountRowVisible,
  loadFormDiscPer,
  loadFormDiscCurr,
  loadBasicIsPercent,
  loadIsTaxExclusive,
  loadDefaultSalesTaxID,
  loadPromoPrompt,
  loadDeletedProds,
  loadFormSellNote,
  loadIsInProgress,
  loadPreventSellRunnerExecution,
  loadParkedSaleModalvisible,
  loadIsMainLoading,
  loadTotalSaving,
  loadSaleRemainingAmount,
  loadIsStoreCreditEnabled,
  loadFormAmountToPay,
  loadIsAllPaid,
  loadSingleScreenPay,
  loadSingleScreenForCart,
  loadEnableTaxCode
} from '../../appRedux/actions/MainSale'
import {
  loadCurrentSalesOrderData,
  loadSaleProductJsonData,
  loadCustomerSearchData,
  loadRefundSaleStatus,
  loadSaleProgressModalShow,
  loadTempSalesOrderData,
  loadSellSelectedAttributes,
  loadShowInventoryPopup,
  loadActionLogs,
  loadShowNumPad,
  loadNumPadType,
  loadNumRelateData,
  loadNumChange,
  loadIsShowSellAttribute,
  loadIsShowCompleteSale,
  loadOutletRegisters,
  loadSellAttribTabs,
  loadSellAttribTabs_type,
  loadIsDiscardSale,
  loadShowNumPadForDiscount,
  loadShowNumPadForPay,
  loadIsRegistorOpen,
  loadIsRegistorLoading,
  loadCashListingLoading,
  loadCashListingDataLoading,
  loadClosedRegData,
  loadOpenCloseListingDataLoad,
  loadSelectedStoreOutlets,
  loadSelectedOutletRegisters
} from '../../appRedux/actions/Sell'
import {
  loadDropDownStates,
  loadEnableAllPOSLayouts,
  loadIsDayPast,
  loadIsSelectReg,
  loadIsShowConfigAttribute,
  loadIsShowConfigSellLayout,
  loadIsStoreCreditOpen,
  loadNotificationBGColor,
  loadNotificationBar,
  loadNotificationHead,
  loadOpenClosePaySummary,
  loadPaymentStatusData,
  loadShowAttribDrop,
  loadUserSelectOutReg
} from '../../appRedux/actions/CommonData'
import {
  SellTaxCalculator,
  SellPromotionCalculator,
  wholeDiscTaxCalculator
} from '../../appRedux/actions/SellScreenMethods'
import { loadDefaultLabelPrintFormat, loadDefaultSKUGeneration } from './Setup'

import {
  READ,
  CREATE,
  UPDATE,
  DELETE,
  ShowProductCosts,
  ApplyDiscounts,
  CreateOrContinueOnAccountSales,
  CreateOrContinueLaybySales,
  IssueManualStoreCredit,
  ReturnAndExchange,
  IssueStoreCreditForReturnSale,
  VoidSalesOnSalesHistory,
  EditSalesOnSaleHistory,
  MakeSales,
  PreparingScreen,
  ServingScreen,
  DashboardReport
} from '../../constants/RightsAndPermissions'
import {
  // REACT_APP_IDENTIFY_BUS_NAME,
  OFFSET_SYNC_ERROR_SALES,
  OFFSET_SYNC_PARKED_SALES,
  OFFSET_SYNC_SALES,
  SALES_ORDER_STATUSES,
  SALE_TRACKING,
  SYNC_CALL_TYPES,
  non_auth_list
} from '../../constants/StoreSetting'
import { SellOrderJsonBuilder } from './SellOrderMethods'
import {
  Tax,
  DefaultSalesTax,
  IsShowSellAttribute,
  IsShowSaleLayout,
  Loyalty,
  LoyaltyAmountValue,
  SCredit,
  LabelPrintFormat,
  SKUGen,
  Printer,
  SingleScreenForCart,
  EnableAllPOSLayouts,
  EnableTaxCodeOnReceipt
} from '../../constants/GeneralSetting'
import { checkPromoPrompt, promoCheckProdSuccess } from './ProdHelperMethods'
import {
  loadPostMainSaleDeleteDataService,
  loadPostMainSaleProductServices
} from '../../appRedux/actions/SellScreenServices'
import {
  loadIsLoyaltyEnabled,
  loadLoyaltyAmountValue
} from '../../appRedux/actions/MainSale'
import ds from '../../Services/DataServices'
import { BEHAVIOUR_TYPE } from '../../Services/DataServices'
import {
  CURRENT_VERSION,
  INDEX_DB_NAME,
  INDEX_DB_TABLES
} from '../../constants/IndexDBData'
import { manageIndexedCartJson } from './saleIndexDB'
import {
  GetIndexDBDataByTableName,
  removeEntitiesDatatoIndexBD,
  saveEntitiesDatatoIndexBD
} from './IndexDBActions'
import moment from 'moment'
import { SIGNIN_USER } from '../../constants/ActionTypes'
import {
  loadAppNetwork,
  loadIsOnline,
  loadLoginLoader,
  login_redirect
} from '.'
import { postDataToApp } from './MobAppFn'
import { PostAppTypes } from '../../constants/MobAppConstants'
import { env } from '../../env'
import { CONFIG_LOGS } from '../../constants/IndexDB_Logs'

const { REACT_APP_IDENTIFY_BUS_NAME } = env

export function generalSettingsStore (data, dispatch) {
  if (data) {
    if (data.printerList && data.printerList.length > 0) {
      const plat = localStorage.getItem('platform_stored')
        ? localStorage.getItem('platform_stored')
        : ''
      const printss = data.printerList.filter(f => f.platform == plat)
      if (printss && printss.length > 0) {
        localStorage.setItem('li_printrz', JSON.stringify(printss))
      } else localStorage.setItem('li_printrz', '0')
    } else localStorage.setItem('li_printrz', '0')
    if (
      data.storeCommonConfigs &&
      data.storeCommonConfigs.storeConfig &&
      data.storeCommonConfigs.storeConfig.generalConfigs &&
      data.storeCommonConfigs.storeConfig.generalConfigs.length > 0
    ) {
      const gen = data.storeCommonConfigs.storeConfig.generalConfigs
      const printConfig = data.printers
      localStorage.setItem('printConfig', '0')
      gen.map(er => {
        if (er.key == Tax) {
          if (er.value == 'True') {
            dispatch(loadIsTaxExclusive(true))
          } else {
            dispatch(loadIsTaxExclusive(false))
          }
        }
        if (er.key == DefaultSalesTax) {
          dispatch(loadDefaultSalesTaxID(er.value))
        }
        if (er.key == IsShowSellAttribute) {
          if (er.value == 'True') {
            dispatch(loadIsShowConfigAttribute(true))
          } else {
            dispatch(loadIsShowConfigAttribute(false))
          }
        }
        if (er.key == IsShowSaleLayout) {
          if (er.value == 'True') {
            dispatch(loadIsShowConfigSellLayout(true))
          } else {
            dispatch(loadIsShowConfigSellLayout(false))
          }
        }
        if (er.key === 'EnableAllPOSLayouts') {
          if (er.value == 'True') {
            dispatch(loadEnableAllPOSLayouts(true))
          } else {
            dispatch(loadEnableAllPOSLayouts(false))
          }
        }

        if (er.key == Loyalty) {
          if (er.value == 'True') {
            dispatch(loadIsLoyaltyEnabled(true))
          } else {
            dispatch(loadIsLoyaltyEnabled(false))
          }
        }
        if (er.key == LoyaltyAmountValue) {
          if (er.value && er.value != '') {
            dispatch(loadLoyaltyAmountValue(er.value))
          } else {
            dispatch(loadLoyaltyAmountValue('0'))
          }
        }
        if (er.key == SCredit) {
          if (er.value == 'True') {
            dispatch(loadIsStoreCreditEnabled(true))
          } else {
            dispatch(loadIsStoreCreditEnabled(false))
          }
        }
        if (er.key == LabelPrintFormat) {
          if (er.value && er.value != '') {
            dispatch(loadDefaultLabelPrintFormat(er.value))
          } else {
            dispatch(loadDefaultLabelPrintFormat('1'))
          }
        }
        if (er.key == SKUGen) {
          if (er.value && er.value != '') {
            dispatch(loadDefaultSKUGeneration(er.value))
          } else {
            dispatch(loadDefaultSKUGeneration('1'))
          }
        }
        if (er.key == Printer) {
          const plat = localStorage.getItem('platform_stored')
            ? localStorage.getItem('platform_stored')
            : ''
          if (
            er.value &&
            er.value != '0' &&
            printConfig.platform &&
            printConfig.platform == plat
          ) {
            localStorage.setItem('printConfig', JSON.stringify(printConfig))
          } else localStorage.setItem('printConfig', '0')
        }
        if (er.key == EnableTaxCodeOnReceipt) {
          if (er.value == 'True') {
            dispatch(loadEnableTaxCode(true))
          } else {
            dispatch(loadEnableTaxCode(false))
          }
        }
      })
    }
  }
}

export function removeSpacewithLowerCaseString (name) {
  return name != undefined && name != ''
    ? name.toString().toLocaleLowerCase().trim().replaceAll(/\s/g, '')
    : ''
}

export function getDecryptID (id) {
  return id && isString(id) && id.includes('&')
    ? id.substring(0, id.indexOf('&'))
    : id
}

export function isEmptyObject (obj) {
  if (obj && obj != undefined) {
    return !Object.keys(obj).length
  } else return true
}

export function StringIsNullOrEmpty (param) {
  return param != null && param != '' ? false : true
}

export function StringIsUndefinedOrEmpty (param) {
  return param != undefined && param != '' ? false : true
}

export function getRandomInt (max, min = 0) {
  return Math.floor(Math.random() * (max - min + 1)) + min // eslint-disable-line no-mixed-operators
}
export function generateRandomString (noOfCharacters) {
  const characters = 'abcdefghijklmnopqrstuvwxyz'
  let result = ''
  const charactersLength = characters.length
  for (let i = 0; i < parseInt(noOfCharacters); i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export function clearAllSale (form, dispatch, notCus, isDiscard) {
  if (form) {
    form.resetFields()
  }
  localStorage.setItem('orderGuidID', '')
  localStorage.setItem('parentOrderGuidID', '')
  dispatch(loadSaleProductJsonData([]))
  dispatch(loadCurrentSalesOrderData({}))
  dispatch(loadSaleOrderJson({}))
  dispatch(loadSalePayments([]))
  dispatch(loadTableDataSaleProduct([]))
  dispatch(loadTableDataSellTax([]))
  dispatch(loadTableDataSellPromotion([]))
  dispatch(loadIsSalePaymentProcessStart(false))
  dispatch(loadIsRefundSale(false))
  // dispatch(loadCurrentSalesOrderStatusID(""));
  dispatch(loadRefundSaleStatus(0))

  dispatch(loadIsPaymentPanelActionCompleteActive(false))
  dispatch(loadIsNotesRowVisible(false))
  dispatch(loadIsPaymentPanelLoading(false))
  dispatch(loadIsSalePanelActive(true))
  dispatch(loadSingleScreenPay(false))
  dispatch(loadRefundProdKeys([]))
  dispatch(loadExchangeSale(false))
  dispatch(loadEarnedLoyalty(0))
  dispatch(
    loadCurrentSalesOrderStatusID(
      SALES_ORDER_STATUSES.filter(a => a.StatusName == 'InProgress')[0]
        .SalesOrderStatuID
    )
  )
  dispatch(loadAccLaybyCreditAmount([]))
  removeSaleDiscount(false, dispatch)
  dispatch(loadBasicIsPercent(true))
  dispatch(loadDeletedProds([]))
  dispatch(loadPromoPrompt({}))
  dispatch(loadFormSellNote(''))
  dispatch(loadIsInProgress(false))
  dispatch(loadTotalSaving(''))
  dispatch(loadSaleRemainingAmount(''))
  dispatch(loadSellSelectedAttributes([]))
  if (!notCus) {
    dispatch(loadCustomerSearchData({}))
  }
  dispatch(loadShowInventoryPopup(false))
  dispatch(loadActionLogs([]))
  dispatch(loadFormAmountToPay(0))
  // // // CLEARING INDEX-DB UN-NECESSARY
  const index_key = localStorage.getItem('index_key')
  clearIndexedInProgress(index_key, isDiscard)
  localStorage.setItem('index_key', ``)
}

export function checkInProgress (obj, paid) {
  return (
    obj.inProgress == true &&
    obj.isCompleted == false &&
    obj.isParked == false &&
    obj.isAllPaid == paid
  )
}

export const clearIndexedInProgress = (index_key, isDiscard) => {
  const inProgressedSales = GetIndexDBDataByTableName(
    INDEX_DB_NAME,
    INDEX_DB_TABLES.SALES
  )
  inProgressedSales
    .then(e => {
      if (e && e.length > 0) {
        const saleArray = []
        const saleExist = e.filter(er => checkInProgress(er, false))
        if (saleExist && saleExist.length > 0) {
          saleExist.map(aa => {
            saleArray.push(aa)
          })
        }
        const parkInProgress = isDiscard
          ? checkInProgressPark(e, index_key)
          : []
        if (parkInProgress && !isEmptyObject(parkInProgress)) {
          saleArray.push(parkInProgress)
        }
        removeEntitiesDatatoIndexBD(
          saleArray,
          INDEX_DB_NAME,
          CURRENT_VERSION,
          INDEX_DB_TABLES.SALES
        )
      }
    })
    .catch(e => {
      console.log('INDEX_DB -> clearIndexedInProgress -->', e)
    })
}

function checkInProgressPark (list, index_key) {
  let parkInProgress = false
  if (index_key && list && list.length > 0) {
    const qq = list.filter(a => a.indexKey == index_key && a.isParked == true)
    if (qq && qq.length > 0) {
      parkInProgress = qq[0]
    }
  }
  return parkInProgress
}

export function notAllowMsgCheck (e) {
  if (e && e.response && e.response.data && e.response.data === 'not allow') {
    message.warn('You do not have Right to perform this...', 5)
  }
}

function getPathUrl (string) {
  let url = ''
  if (string) {
    const isIncludeLocalhost =
      string.includes('local') || string.includes(REACT_APP_IDENTIFY_BUS_NAME)
    let crumbs = string.includes('/') ? string.split('/') : []
    const startIndex = isIncludeLocalhost ? 1 : 0
    const endIndex = isIncludeLocalhost ? 5 : 4
    crumbs.length > 0 &&
      crumbs.map((e, i) => {
        if (i > startIndex && i < endIndex) {
          url += e.toLowerCase()
        }
      })
  }
  return url
}

export function getCurrentPageID () {
  let pageID = false
  const menus = localStorage.getItem('menu')
    ? JSON.parse(localStorage.getItem('menu'))
    : {}
  const incomingPath = getPathUrl(window.location.pathname)
  if (menus && !isEmptyObject(menus)) {
    pageID =
      menus.menus.filter(ww => getPathUrl(ww.menuURL) === incomingPath).length >
      0
        ? menus.menus.filter(ww => getPathUrl(ww.menuURL) === incomingPath)[0]
            .pageID
        : false
  }
  return pageID
}

export function checkRightspermissions (rightsPermissions) {
  let data = {}
  let rites = []
  let permissions = []
  const respData =
    rightsPermissions &&
    rightsPermissions.storeCommonConfigs &&
    rightsPermissions.storeCommonConfigs.storeConfig
      ? rightsPermissions.storeCommonConfigs.storeConfig
      : {}
  if (respData && respData.pageRiteAndPermission) {
    if (
      respData.pageRiteAndPermission.rites &&
      respData.pageRiteAndPermission.rites.length > 0
    ) {
      rites = respData.pageRiteAndPermission.rites
    }
    if (
      respData.pageRiteAndPermission.permission &&
      respData.pageRiteAndPermission.permission.length > 0
    ) {
      permissions = respData.pageRiteAndPermission.permission
    }
  }
  //checking rights
  if (rites.length > 0) {
    data.rights = rites
    if (rites.filter(a => a == READ).length > 0) {
      data.read = true
    }
    if (rites.filter(a => a == CREATE).length > 0) {
      data.create = true
    }
    if (rites.filter(a => a == UPDATE).length > 0) {
      data.update = true
    }
    if (rites.filter(a => a == DELETE).length > 0) {
      data.delete = true
    }
  }
  //checking permissions
  if (permissions && permissions.length > 0) {
    data.permissions = permissions
    if (permissions.filter(a => a == ApplyDiscounts).length > 0) {
      data.applyDiscount = true
    }
    if (
      permissions.filter(a => a == CreateOrContinueOnAccountSales).length > 0
    ) {
      data.accountSale = true
    }
    if (permissions.filter(a => a == CreateOrContinueLaybySales).length > 0) {
      data.laybySale = true
    }
    if (permissions.filter(a => a == IssueManualStoreCredit).length > 0) {
      data.manualStoreCredit = true
    }
    if (
      permissions.filter(a => a == IssueStoreCreditForReturnSale).length > 0
    ) {
      data.returnSaleStoreCredit = true
    }
    if (permissions.filter(a => a == MakeSales).length > 0) {
      data.makeSales = true
    }
    if (permissions.filter(a => a == ReturnAndExchange).length > 0) {
      data.returnAndExchange = true
    }
    if (permissions.filter(a => a == VoidSalesOnSalesHistory).length > 0) {
      data.voidAllow = true
    }
    if (permissions.filter(a => a == EditSalesOnSaleHistory).length > 0) {
      data.editAllow = true
    }
    if (permissions.filter(a => a == ServingScreen).length > 0) {
      data.servingAllow = true
    }
    if (permissions.filter(a => a == PreparingScreen).length > 0) {
      data.preparingAllow = true
    }
    if (permissions.filter(a => a == DashboardReport).length > 0) {
      data.dashboardReportAllow = true
    }
  }
  return data
}

export function checkScreenAccess (page) {
  let allow = false
  const menuNavigationData = localStorage.getItem('menu')
  const data = JSON.parse(menuNavigationData)
  if (data && data.menus && data.menus.length > 0 && page) {
    data.menus.map(a => {
      if (a.pageID == page) {
        allow = true
      }
    })
  }
  return allow
}

export function checkIssueStoreCredit (dispatch) {
  // let returnVal = false;
  // const result = dispatch(setCommsdsdonConfigs(MAIN_SALE_SCREEN, false, true));
  // if(result && result.storeCommonConfigs && result.storeCommonConfigs.storeConfig){
  //   const data = result.storeCommonConfigs.storeConfig;
  //   const permissions = [];
  //   if(data.pageRiteAndPermission.permission){
  //     permissions = data.pageRiteAndPermission.permission;
  //   }
  //   if(permissions && permissions.length > 0){
  //     if (permissions.filter((a) => a == IssueManualStoreCredit).length > 0) {
  //       return true;
  //     }
  //   }
  // }
  // return returnVal;
}

export function ApplyCustomerAccountDetails (
  dispatch,
  customerData,
  getStorePaymentTypes,
  getDefaultDecimalPlaces,
  getIsRefundSale,
  getReturnStoreCredit,
  getIsLoyaltyEnabled,
  getIsStoreCreditEnabled
) {
  let data = customerData
  let customerAccountDetails = []
  let storePaymentTypes = getStorePaymentTypes
  // let storePaymentTypes = StorePaymentTypes;

  if (!isEmptyObject(data)) {
    if (data.customerSId != '') {
      customerAccountDetails = [
        {
          CustomerID: data.customerSId,
          AmountType: 'Account Balance',
          Amount:
            data.accountCredit != null && data.accountCredit != undefined
              ? formatDigits(data.accountCredit, getDefaultDecimalPlaces)
              : (0.0).toFixed(getDefaultDecimalPlaces)
        },
        {
          CustomerID: data.customerSId,
          AmountType: 'Store Credit',
          Amount:
            data.storeCredit != null && data.storeCredit != undefined
              ? formatDigits(data.storeCredit, getDefaultDecimalPlaces)
              : (0.0).toFixed(getDefaultDecimalPlaces)
        }
      ]

      const loyaltyObj = {
        CustomerID: data.customerSId,
        AmountType: 'Loyalty',
        Amount:
          data.loyaltyValue != null && data.loyaltyValue != undefined
            ? formatDigits(data.loyaltyValue, getDefaultDecimalPlaces)
            : (0.0).toFixed(getDefaultDecimalPlaces)
      }
      if (
        data.loyaltyValue != null &&
        data.loyaltyValue != undefined &&
        data.loyaltyValue > 0
      ) {
        customerAccountDetails.push(loyaltyObj)
      }

      const tempStorePaymentTypes =
        storePaymentTypes &&
        storePaymentTypes.map(e => {
          let isDisabled = true
          if (e.GatewayName == 'storecredit') {
            if (getIsRefundSale) {
              isDisabled = getReturnStoreCredit ? false : true
            } else {
              isDisabled =
                getIsStoreCreditEnabled &&
                data.storeCredit &&
                data.storeCredit > 0
                  ? false
                  : true
            }
          } else if (e.GatewayName == 'loyalty') {
            isDisabled =
              !getIsRefundSale &&
              getIsLoyaltyEnabled &&
              data.loyaltyValue &&
              data.loyaltyValue > 0
                ? false
                : true
          }
          return {
            sStorePaymentTypeID: e.sStorePaymentTypeID,
            PaymentTypeName: e.PaymentTypeName,
            GatewayName: e.GatewayName,
            IsDisabled: isDisabled
          }
        })
      dispatch(loadStorePaymentTypes(tempStorePaymentTypes))
    }
  } else {
    customerAccountDetails = [
      {
        CustomerID: '',
        AmountType: 'Account Balance',
        Amount: (0.0).toFixed(getDefaultDecimalPlaces)
      },
      {
        CustomerID: data.customerSId,
        AmountType: 'Store Credit',
        Amount: (0.0).toFixed(getDefaultDecimalPlaces)
      }
    ]

    const tempStorePaymentTypes =
      storePaymentTypes &&
      storePaymentTypes.map(e => {
        return {
          sStorePaymentTypeID: e.sStorePaymentTypeID,
          PaymentTypeName: e.PaymentTypeName,
          GatewayName: e.GatewayName,
          IsDisabled: true
        }
      })
    dispatch(loadStorePaymentTypes(tempStorePaymentTypes))
  }
  dispatch(loadCustomerAccountDetails(customerAccountDetails))
}

export function EnableDisableSaleStatusesByCustomer (
  dispatch,
  customerData,
  getSalesOrderStatuses,
  getLaySalePerm,
  getAccountSalePerm,
  getIsRefundSale,
  getCurrentSalesOrderStatusID
) {
  let data = customerData
  let saleStatuses = getSalesOrderStatuses
  // let saleStatuses = SalesOrderStatuses;
  if (data && !isEmptyObject(data) && data.customerSId != '') {
    const tempsaleStatuses =
      saleStatuses &&
      saleStatuses.map(e => {
        let disabled = false
        if (getIsRefundSale) {
          disabled = true
        } else {
          if (
            getDecryptID(getCurrentSalesOrderStatusID) == '1' ||
            getDecryptID(getCurrentSalesOrderStatusID) == '2' ||
            getDecryptID(getCurrentSalesOrderStatusID) == '4' ||
            getDecryptID(getCurrentSalesOrderStatusID) == '5'
          ) {
            disabled = true
          } else if (getDecryptID(e.SalesOrderStatuID) == '1') {
            disabled = !getLaySalePerm
          } else if (getDecryptID(e.SalesOrderStatuID) == '2') {
            disabled = !getAccountSalePerm
          }
        }
        return {
          SalesOrderStatuID: e.SalesOrderStatuID,
          StatusName: e.StatusName,
          IsActive: e.IsActive,
          IsDisabled: disabled
        }
      })
    dispatch(loadSalesOrderStatuses(tempsaleStatuses))
  } else {
    const tempsaleStatuses =
      saleStatuses &&
      saleStatuses.map(e => {
        return {
          SalesOrderStatuID: e.SalesOrderStatuID,
          StatusName: e.StatusName,
          IsActive: e.IsActive,
          IsDisabled: true
        }
      })
    dispatch(loadSalesOrderStatuses(tempsaleStatuses))
  }
}

export function onAccLayBySaleEffects (
  customer,
  getAccLaybyCreditAmount,
  amountToPay,
  credit,
  dispatch
) {
  const amount = credit != false && amountToPay > credit ? credit : amountToPay
  let customerData = customer
  const saleAmountValue =
    getAccLaybyCreditAmount && getAccLaybyCreditAmount.length > 1
      ? getAccLaybyCreditAmount[1]
      : getAccLaybyCreditAmount && getAccLaybyCreditAmount.length > 0
      ? getAccLaybyCreditAmount[0]
      : 0
  const saleAmountBkup =
    parseFloat(parseFloat(saleAmountValue).toFixed(2)) -
    parseFloat(parseFloat(amount).toFixed(2))
  if (saleAmountBkup >= 0) {
    // only > than the amount of original account sale
    const bckupValue =
      getAccLaybyCreditAmount && getAccLaybyCreditAmount.length > 0
        ? [getAccLaybyCreditAmount[0], saleAmountBkup]
        : [0, saleAmountBkup]
    dispatch(loadAccLaybyCreditAmount(bckupValue))
    customerData.accountCredit -= amount
  }
  return customerData
}

export function clusterCalculations (
  tempSaleProductsJson,
  getSelectedOutlet,
  getSelectedReg,
  getBasicIsPercent,
  getCustomerSearchData,
  getIsRefundSale,
  getDefaultDecimalPlaces,
  getCurrentSalesOrderData,
  getCurrentSalesOrderStatusID,
  formDiscountPrice,
  formDiscountPercentage,
  formSellNotes,
  getRefundKeys,
  getSalePayments,
  dispatch,
  promoList,
  isExclusive,
  isFirstRefund,
  getSavings,
  attribProps
) {
  const cussGroupID =
    getCustomerSearchData && getCustomerSearchData.customerGroupId
      ? getCustomerSearchData.customerGroupId
      : ''
  SellTaxCalculator(tempSaleProductsJson, dispatch)
  SellPromotionCalculator(tempSaleProductsJson, dispatch)
  const is_all_paid = SellOrderJsonBuilder(
    tempSaleProductsJson,
    getSelectedOutlet,
    getSelectedReg,
    getBasicIsPercent,
    getCustomerSearchData,
    getIsRefundSale,
    getDefaultDecimalPlaces,
    getCurrentSalesOrderData,
    getCurrentSalesOrderStatusID,
    formDiscountPrice,
    formDiscountPercentage,
    formSellNotes,
    getRefundKeys,
    getSalePayments,
    dispatch,
    false,
    isExclusive,
    isFirstRefund,
    getSavings,
    attribProps
  )
  checkPromoPrompt(tempSaleProductsJson, promoList, cussGroupID, dispatch)
  dispatch(loadRowDataUpdated(true))
  dispatch(loadIsPaymentPanelLoading(false))

  if (is_all_paid && is_all_paid == 1) {
    dispatch(loadIsAllPaid(1))
  } else dispatch(loadIsAllPaid(0))
}

export function removeSaleDiscount (isRowVisible, dispatch) {
  dispatch(loadFormDiscPer(0))
  dispatch(loadFormDiscCurr(0))
  dispatch(loadIsDiscountRowVisible(isRowVisible))
}

export function saleIsInProgress (dispatch, incomingData) {
  dispatch(loadIsInProgress(false))
  dispatch(loadSaleProgressModalShow(true))
  dispatch(loadTempSalesOrderData(incomingData))
  // setPreventSellRunnerExecution(false);
  dispatch(loadPreventSellRunnerExecution(false))
}

export function parkSale (
  getSaleOrderJson,
  getSalesOrderStatuses,
  getCurrentSalesOrderData,
  loadNewSale,
  isRefundSale,
  dispatch,
  payData,
  sellSelectedAttribs,
  sellActionLog,
  deletedProds,
  isOnline
) {
  let body = getSaleOrderJson ? getSaleOrderJson : { DeletedProds: [] }
  body.DeletedProds = deletedProds
  if (!body.E_OutletID || !body.E_RegisterID) {
    if (!body.E_OutletID) {
      let selectedLocalOut = localStorage.getItem('selectedOut')
      if (selectedLocalOut) {
        selectedLocalOut = JSON.parse(selectedLocalOut)
        const outID = selectedLocalOut.id
        body.E_OutletID = outID
      }
    }
    if (!body.E_RegisterID) {
      let selectedLocalReg = localStorage.getItem('selectedReg')
      if (selectedLocalReg) {
        selectedLocalReg = JSON.parse(selectedLocalReg)
        const regID = selectedLocalReg.id
        body.E_RegisterID = regID
      }
    }
  }

  const statusID = body.E_SalesOrderStatusID ? body.E_SalesOrderStatusID : ''
  if (getDecryptID(statusID) == '1' || getDecryptID(statusID) == '2') {
    // if on account or layby is in progress just leave it as it is and load the incoming
    loadIncomingSale(loadNewSale, dispatch)
  } else {
    //NOTE: Saving action logs for only parked sale because thats the end point of in progress sale of cart otherwise from status api
    if (!isRefundSale) {
      body.ActionLog =
        sellActionLog && sellActionLog.length > 0 ? sellActionLog : []
    }
    body.E_SalesOrderStatusID = isRefundSale
      ? '14&&_9efa-1ea9-4faf-88ed-a48e65b46643'
      : '3&&_9efa-1ea9-4faf-88ed-a48e65b46643'
    const cashRegPay = localStorage.getItem('cashManageID')
    if (cashRegPay && cashRegPay != '') {
      body.CashRegPaymentID = cashRegPay
      dispatch(loadIsMainLoading(true))
      if (isOnline) {
        dispatch(
          loadPostMainSaleProductServices(
            body,
            getSalesOrderStatuses,
            getCurrentSalesOrderData,
            false,
            loadNewSale,
            false,
            false,
            payData,
            sellSelectedAttribs,
            []
          )
        )
      } else {
        message.success('Sale Parked Successfully')
        loadIncomingSale(loadNewSale, dispatch)
        dispatch(loadIsMainLoading(false))
      }
      let parkHelper = {
        isOnline: isOnline,
        create_body: body
      }
      body.attribProps =
        sellSelectedAttribs && sellSelectedAttribs.length > 0
          ? sellSelectedAttribs
          : []
      if (body.attribProps && body.attribProps.length > 0) {
        body.attribProps.map(a => {
          if (typeof a.sellAttribID !== 'string') {
            a.sellAttribID = ''
          }
        })
      }
      manageIndexedCartJson(body, false, false, true, 'parkSale', parkHelper) // NOTE: helper is using with createBody object setting && send isOnline only be true if system is with internet along with isParked true
      // const receipt_code = `${getCurrentSalesOrderData.indexKey}`
      // currOrderSale.receiptCode = receipt_code
      // salesOrder.receiptCode = receipt_code
      // dispatch(loadCurrentSalesOrderData(currOrderSale))
      // dispatch(loadSaleOrderJson(salesOrder))
      // storeCreatePayload(getCurrentSalesOrderData.indexKey, body, receipt_code) // NOTE: payload for syncing the offline parked sale
    } else {
      message.warn('Kindly recheck register is open & selected', 4)
    }
  }
  dispatch(loadFormSellNote(''))
  dispatch(loadParkedSaleModalvisible(false))
}

export function loadIncomingSale (loadNewSale, dispatch) {
  clearAllSale(false, dispatch, false)
  if (!isEmptyObject(loadNewSale)) {
    dispatch(loadFormSellNote(loadNewSale.notes ? loadNewSale.notes : ''))
    if (loadNewSale.isRefund) {
      // if incoming sale is refund
      dispatch(loadIsRefundSale(true))
      dispatch(loadRefundSaleStatus(0))
      const isParkReturn =
        getDecryptID(loadNewSale.sSalesOrderStatusID) ==
        getDecryptID(fetchCurrentSalesOrder('Parked, return'))
      const parentKey = isParkReturn
        ? loadNewSale.sParentSalesOrderID
        : loadNewSale.key
      localStorage.setItem('parentOrderGuidID', parentKey)
      localStorage.setItem('orderGuidID', '')
      loadNewSale.e_ParentSalesOrderID = parentKey
      loadNewSale.key = isParkReturn ? loadNewSale.key : ''
    } else {
      localStorage.setItem('orderGuidID', loadNewSale.key)
    }
    // for customer
    if (loadNewSale.customer && loadNewSale.customer.length > 0) {
      let customer = {}
      customer = loadNewSale.customer[0]
      const firstLetter = customer.customerFirstName
        ? customer.customerFirstName.charAt(0)
        : 'x'
      const secondLetter = customer.customerLastName
        ? customer.customerLastName.charAt(0)
        : 'y'
      const lettersName = firstLetter.toUpperCase() + secondLetter.toUpperCase()
      customer.letterName = lettersName
      dispatch(loadCustomerSearchData(customer))
    } else {
      dispatch(loadCustomerSearchData({}))
    }
    //setting sell attributes
    let sellAttribs = []
    if (loadNewSale.sellAttributes && loadNewSale.sellAttributes.length > 0) {
      sellAttribs = loadNewSale.sellAttributes
    }
    dispatch(loadSellSelectedAttributes(sellAttribs))
    setDiscCurrPerNote(loadNewSale, dispatch)
    dispatch(loadPreventSellRunnerExecution(false))
    dispatch(loadCurrentSalesOrderData(loadNewSale))
  }
}

export function checkSubPerm (perm, trial, enterprise, id) {
  let permission = false
  if (trial || enterprise) {
    permission = true
  } else {
    if (perm && perm.length > 0) {
      const data = perm.filter(a => getDecryptID(a.subscriptionFeatureID) == id)
      if (data && data.length > 0) {
        const isAllow = data[0].access ? data[0].access : false
        permission = isAllow
      }
    }
  }
  return permission
}

export function setDiscCurrPerNote (data, dispatch) {
  const per = data.discountPercentage ? data.discountPercentage : 0
  const isPer = data.discountIsPercentage ? data.discountIsPercentage : false
  const curr =
    !isPer && data.salesOrderDiscountPrice ? data.salesOrderDiscountPrice : 0
  const note = data.notes ? data.notes : ''
  dispatch(loadFormDiscPer(per))
  dispatch(loadFormSellNote(note))
  dispatch(loadBasicIsPercent(isPer))
  dispatch(loadFormDiscCurr(curr))
  if (per || curr) {
    dispatch(loadIsDiscountRowVisible(true))
  } else {
    dispatch(loadIsDiscountRowVisible(false))
    dispatch(loadBasicIsPercent(true))
  }
}

export function applyDiscountOnSale (
  discountPriceTotal,
  discounCountIsPercentage,
  discountPercentage,
  discountPrice,
  wholeRemoved,
  prodsss,
  finals,
  dispatch,
  isExclusive,
  taxTotal,
  isRefund,
  isLayByAccount,
  finalInc,
  finalExc,
  isAccountRefund
) {
  const prods = prodsss && prodsss.length > 0 ? [...prodsss] : []
  if (discountPriceTotal != undefined && discountPriceTotal != 0) {
    let excDeductPrice = 0
    // *** NOTE: *** Special thing to note is --> Since we already know the percentage of amount put Discount then why are we calculating again ? Make things simpler by converting the amount discount into % and run the logic accordingly
    discounCountIsPercentage = true
    if (discounCountIsPercentage) {
      excDeductPrice = finalExc * (discountPercentage / 100)
    } else {
      excDeductPrice = isExclusive
        ? discountPrice
        : (discountPrice / finalInc) * finalExc
    }

    excDeductPrice =
      Math.sign(excDeductPrice) == -1 ? excDeductPrice * -1 : excDeductPrice
    discountPriceTotal =
      Math.sign(discountPriceTotal) == -1
        ? discountPriceTotal * -1
        : discountPriceTotal

    const tempDataStore = []
    let taxDisc = 0
    let discAmendPrice = discountPrice
    let lengthHelper = 0
    let prodLength = 0
    if (isRefund || isLayByAccount) {
      prods.map(dds => {
        if (isAccountRefund) {
          if (dds.isRefund && dds.isOnAccount) {
            prodLength += 1
          }
        } else if (isRefund && dds.isRefund) {
          prodLength += 1
        } else if (isLayByAccount) {
          if (dds.isOnAccount) {
            prodLength += 1
          }
        }
      })
    } else {
      prodLength = prods.length
    }
    for (let k = 0; k < prods.length; k++) {
      let isAllow = true // in refund && layby, onAccount disc won't apply on new incoming prods
      if (isAccountRefund) {
        if (!prods[k].isRefund || !prods[k].isOnAccount) {
          isAllow = false
        }
      } else if (isRefund && !prods[k].isRefund) {
        isAllow = false
      } else if (isLayByAccount) {
        if (!prods[k].isOnAccount) {
          isAllow = false
        }
      }

      let appliedPrice =
        !discounCountIsPercentage && !isExclusive
          ? prods[k].totals.inclusivePrice
          : prods[k].totals.exclusivePrice
      // appliedPrice = isAccountRefund && prods[k].isRefund && prods[k].isOnAccount &&
      //   appliedPrice < 0 ? appliedPrice * -1 : appliedPrice;
      let priceCopyForExcDiscValue = appliedPrice
      if (isAllow) {
        if (!discounCountIsPercentage) {
          appliedPrice -= discAmendPrice / (prodLength - lengthHelper)
          if (appliedPrice <= 0) {
            discAmendPrice -= priceCopyForExcDiscValue
            lengthHelper += 1
          }
          // appliedPrice = Math.sign(appliedPrice) == -1 ? appliedPrice * -1 : appliedPrice;
        } else {
          const priceValue =
            appliedPrice - appliedPrice * (discountPercentage / 100)
          appliedPrice = priceValue
        }
      }
      if (
        prods[k] &&
        prods[k].taxComponents &&
        !isEmptyObject(prods[k].taxComponents)
      ) {
        priceCopyForExcDiscValue = appliedPrice
        let mapped = prods[k].taxComponents.map(obj => {
          if (!discounCountIsPercentage && !isExclusive && !obj.isFix) {
            //in inclusive && value discount --> discount minus total inclusive then find out exclusive from this
            let notFixPercentSum = 0
            prods[k].taxComponents.map(bb => {
              if (!bb.isFix) {
                notFixPercentSum += bb.taxRate
              }
            })
            const exccc = getExcPriceFromInc(
              notFixPercentSum,
              priceCopyForExcDiscValue
            )
            appliedPrice = exccc
          }
          const tax = obj.isFix ? obj.total_tax : appliedPrice * obj.taxRate
          taxDisc += tax
          return {
            isFix: obj.isFix ? obj.isFix : false,
            key: obj.taxId,
            sellTaxName: obj.taxName,
            sellTaxRate: obj.taxRate,
            sellTaxPrice: tax
          }
        })
        tempDataStore.push(mapped)
      }
    }

    taxTotal = taxDisc
    const accTax = wholeDiscTaxCalculator(tempDataStore, dispatch)
    finals.exc =
      isRefund || finals.exc < 0
        ? finals.exc + excDeductPrice
        : finals.exc - excDeductPrice
    if (isExclusive) {
      finals.inc = finals.exc + accTax.tax
    } else {
      finals.inc =
        isRefund || finals.inc < 0
          ? finals.inc + discountPriceTotal
          : finals.inc - discountPriceTotal
    }
  } else if (wholeRemoved && wholeRemoved > 0) {
    //tax effect
    // prods.map(iop => {
    //   let totalProdTax = 0;
    //   iop.taxComponents.map(kkk => {
    //     // const totalBPrice = iop.totals && iop.totals.inclusiveBasePrice ? iop.totals.inclusiveBasePrice : iop.basePrice + kkk.total_tax;
    //     // const valPercent = (wholeRemoved / totalBPrice) * 100;
    //     // const baseTotalTax = iop.basePrice * iop.displayQuantity * kkk.taxRate;
    //     // kkk.total_tax = kkk.total_tax + (baseTotalTax * valPercent / 100);
    //     // kkk.total_tax = kkk.total_tax + (baseTotalTax * valPercent / 100);
    //     kkk.total_tax = kkk.replica;
    //     totalProdTax += kkk.total_tax;
    //   });
    //   iop.totalTax = totalProdTax;
    // });
    SellTaxCalculator(prods, dispatch)
  }
  return {
    // prods: prods,
    finals: finals,
    taxTotal: taxTotal
  }
}

export function fetchCurrentSalesOrder (type) {
  return type &&
    SALES_ORDER_STATUSES.filter(a => a.StatusName == type).length > 0
    ? SALES_ORDER_STATUSES.filter(a => a.StatusName == type)[0]
        .SalesOrderStatuID
    : ''
}

export function formatDigits (value, decimal) {
  let da =
    value && isString(value) && value.includes(',')
      ? value.replace(',', '')
      : value
  return parseFloat(da ? da : 0)
    .toFixed(decimal)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function customParse (value) {
  let da =
    value && isString(value) && value.includes(',')
      ? value.replace(',', '')
      : value
  const res = parseFloat(da ? parseFloat(da).toFixed(2) : 0)
  return res
}

export function dynamoParse (value, decimal) {
  let da =
    value && isString(value) && value.includes(',')
      ? value.replace(',', '')
      : value
  const res = parseFloat(da ? parseFloat(da).toFixed(decimal ? decimal : 2) : 0)
  return res
}

export function parseFloatCustom (value) {
  let da =
    value && isString(value) && value.includes(',')
      ? value.replace(',', '')
      : value
  const res = parseFloat(da ? da : 0)
  return res
}

export function parseIntCustom (value) {
  let da =
    value && isString(value) && value.includes(',')
      ? value.replace(',', '')
      : value
  const res = parseInt(da ? da : 0)
  return res
}

export function isString (value) {
  return typeof value === 'string' || value instanceof String
}

export function disableAccLayBy (getSalesOrderStatuses, dispatch) {
  const saleStatuses = getSalesOrderStatuses
  const tempsaleStatuses =
    saleStatuses &&
    saleStatuses.map(e => {
      let disabled = false
      if (getDecryptID(e.SalesOrderStatuID) == '1') {
        disabled = true
      } else if (getDecryptID(e.SalesOrderStatuID) == '2') {
        disabled = true
      }
      return {
        SalesOrderStatuID: e.SalesOrderStatuID,
        StatusName: e.StatusName,
        IsActive: e.IsActive,
        IsDisabled: disabled
      }
    })
  dispatch(loadSalesOrderStatuses(tempsaleStatuses))
}

export function getNominatedProds (condProds, prod, prods, isPromoAll) {
  let nominates = []
  if (isPromoAll) {
    const incomeKeyy = prod.key ? prod.key : 0
    prods = prods.filter(xx => xx.key != incomeKeyy) // if incoming prod already exist in list prods then eliminate it from prods list first
    prods.push(prod)
    nominates = prods
    nominates.map(q => {
      if (q.key == prod.key) {
        q.incoming = true
      }
    })
  } else {
    condProds.map(a => {
      const prodExist = promoCheckProdSuccess([a], prod.identityInfo, false)
      if (prodExist) {
        // getDecryptID(prod.sProductID) == getDecryptID(a.productID)
        prod.incoming = true
        nominates.push(prod)
      }
      const inListProds = []
      prods.map(f => {
        const _prodExist = promoCheckProdSuccess([a], f.identityInfo, false)
        if (_prodExist) {
          inListProds.push(f)
        }
      })
      // const inListProds = prods.filter(
      //   x => getDecryptID(x.sProductID) == getDecryptID(a.productID)
      // )
      if (inListProds && inListProds.length > 0) {
        inListProds.map(z => {
          const incomeKey = prod.key ? prod.key : 0
          if (z.key && z.key != incomeKey) {
            nominates.push(z)
          }
        })
      }
    })
  }
  return nominates
}

export function getImplementationCount (
  condProds,
  prod,
  prods,
  isPromoAll,
  rewardProds,
  isGetAll,
  buy,
  getQuantity,
  spend,
  isExc,
  pbInfo
) {
  let count = 0
  let nominates = []
  const incomeKeyy = prod.key ? prod.key : 0
  prods = prods.filter(xx => xx.key != incomeKeyy) // if incoming prod already exist in list prods then eliminate it from prods list first
  prods.push(prod)
  nominates = prods
  if (nominates && nominates.length > 0) {
    if (buy) {
      let assumptionCondCountBuy = 0
      let assumptionPromoCountBuy = 0
      let promoCondNominatedBuy = [...nominates]
      let promoApplyNominatedBuy = [...nominates]
      //gather prods from which the promo cond meet
      if (!isPromoAll) {
        const keys = []
        promoCondNominatedBuy.map(q => {
          const prodExist = promoCheckProdSuccess(
            condProds,
            q.identityInfo,
            false
          )
          // const isExist =
          //   condProds && condProds.length > 0
          //     ? condProds.filter(
          //         s => getDecryptID(s.productID) == getDecryptID(q.sProductID)
          //       )
          //     : []
          if (!prodExist) {
            // isExist && isExist.length == 0
            keys.push(q.key)
          }
        })

        //removing extra prods from list
        keys.map(p => {
          promoCondNominatedBuy = promoCondNominatedBuy.filter(k => k.key != p)
        })
      }

      //gather prods upon which the promo will apply
      if (!isGetAll) {
        const keyss = []
        promoApplyNominatedBuy.map(q => {
          const prodExist_ = promoCheckProdSuccess(
            condProds,
            q.identityInfo,
            false
          )
          // const isExist =
          //   condProds && condProds.length > 0
          //     ? condProds.filter(
          //         s => getDecryptID(s.productID) == getDecryptID(q.sProductID)
          //       )
          //     : []
          if (!prodExist_) {
            // isExist && isExist.length == 0
            keyss.push(q.key)
          }
        })

        //removing extra prods from list
        keyss.map(p => {
          promoApplyNominatedBuy = promoApplyNominatedBuy.filter(
            k => k.key != p
          )
        })
      }

      let totalBuyCount = 0
      promoCondNominatedBuy.map(qw => {
        totalBuyCount += qw.displayQuantity
      })
      assumptionCondCountBuy = Math.floor(totalBuyCount / buy)

      let totalMeetCount = 0
      promoApplyNominatedBuy.map(qw => {
        totalMeetCount += qw.displayQuantity
      })
      assumptionPromoCountBuy = Math.floor(totalMeetCount / getQuantity)

      if (assumptionCondCountBuy > assumptionPromoCountBuy) {
        count = assumptionPromoCountBuy
      } else if (assumptionPromoCountBuy > assumptionCondCountBuy) {
        count = assumptionCondCountBuy
      } else if (assumptionPromoCountBuy == assumptionCondCountBuy) {
        count = assumptionPromoCountBuy
      }

      //recheck the apply time count
      let recheckCount = 0
      if (!isPromoAll && !isGetAll) {
        const keyCheck = []
        nominates.map(x => {
          const prodExist__ = promoCheckProdSuccess(
            condProds,
            x.identityInfo,
            false
          )
          // const condContained =
          //   condProds && condProds.length > 0
          //     ? condProds.filter(
          //         z => getDecryptID(z.productID) == getDecryptID(x.sProductID)
          //       )
          //     : []
          const rewardContained =
            rewardProds && rewardProds.length > 0
              ? rewardProds.filter(
                  z => getDecryptID(z.productID) == getDecryptID(x.sProductID)
                )
              : []
          if (!prodExist__ && rewardContained.length == 0) {
            // condContained.length == 0
            keyCheck.push(x.key)
          }
        })

        //removing contained keyCheck
        keyCheck.map(c => {
          nominates = nominates.filter(v => v.key != c)
        })
      }

      // calculating implementation times possibilities
      let totalCount = 0
      nominates.map(a => {
        totalCount += a.displayQuantity
      })
      const buyGetQuantity = buy + getQuantity
      recheckCount = Math.floor(totalCount / buyGetQuantity)
      //recheck the apply time count
      if (count != recheckCount) {
        count = recheckCount
      }

      // const keys = [];
      // // filtering those prods which are not included in reward && condition
      // if (!isPromoAll && !isGetAll) {
      //   nominates.map(x => {
      //     const condContained = condProds && condProds.length > 0 ?
      //       condProds.filter(z => getDecryptID(z.productID) == getDecryptID(x.sProductID)) : [];
      //     const rewardContained = rewardProds && rewardProds.length > 0 ?
      //       rewardProds.filter(z => getDecryptID(z.productID) == getDecryptID(x.sProductID)) : [];
      //     if (condContained.length == 0 && rewardContained.length == 0) {
      //       keys.push(x.key);
      //     }
      //   });

      //   //removing contained keys
      //   keys.map(c => {
      //     nominates = nominates.filter(v => v.key != c);
      //   });
      // }

      // // calculating implementation times possibilities
      // let totalCount = 0;
      // nominates.map(a => {
      //   totalCount += a.displayQuantity;
      // });
      // const buyGetQuantity = buy + getQuantity;
      // count = Math.floor(totalCount / buyGetQuantity);
    } else if (spend) {
      let assumptionCondCount = 0
      let assumptionPromoCount = 0
      let promoCondNominated = [...nominates]
      let promoApplyNominated = [...nominates]
      //gather prods from which the promo cond meet
      if (!isPromoAll) {
        const keys = []
        promoCondNominated.map(q => {
          const _prodExist = promoCheckProdSuccess(
            condProds,
            q.identityInfo,
            false
          )
          // const isExist =
          //   condProds && condProds.length > 0
          //     ? condProds.filter(
          //         s => getDecryptID(s.productID) == getDecryptID(q.sProductID)
          //       )
          //     : []
          if (!_prodExist) {
            // isExist && isExist.length == 0
            keys.push(q.key)
          }
        })

        //removing extra prods from list
        keys.map(p => {
          promoCondNominated = promoCondNominated.filter(k => k.key != p)
        })
      }

      //gather prods upon which the promo will apply
      if (!isGetAll) {
        const keysss = []
        promoApplyNominated.map(q => {
          const __prodExist = promoCheckProdSuccess(
            condProds,
            q.identityInfo,
            false
          )
          // const isExist =
          //   condProds && condProds.length > 0
          //     ? condProds.filter(
          //         s => getDecryptID(s.productID) == getDecryptID(q.sProductID)
          //       )
          //     : []
          if (!__prodExist) {
            // isExist && isExist.length == 0
            keysss.push(q.key)
          }
        })

        //removing extra prods from list
        keysss.map(p => {
          promoApplyNominated = promoApplyNominated.filter(k => k.key != p)
        })
      }

      let considerPrice = 0
      promoCondNominated.map(g => {
        const price = isExc
          ? g.bestPriceBookInfo.price
          : g.bestPriceBookInfo.price + g.bestPriceBookInfo.tax
        considerPrice += price * g.displayQuantity
      })

      let prodTotalCount = 0
      promoApplyNominated.map(f => {
        prodTotalCount += f.displayQuantity
      })

      assumptionCondCount = Math.floor(considerPrice / spend)
      assumptionPromoCount = Math.floor(prodTotalCount / getQuantity)

      if (assumptionCondCount > assumptionPromoCount) {
        count = assumptionPromoCount
      } else if (assumptionPromoCount > assumptionCondCount) {
        count = assumptionCondCount
      } else if (assumptionPromoCount == assumptionCondCount) {
        count = assumptionCondCount
      }

      //rechecking
      let prodDatas = nominates
      let proceed = true
      let jackCount = 0
      for (let i = 1; i <= count; i++) {
        if (proceed) {
          // marking booking count
          const bookContainKeys = []
          let spendPrice = spend
          let getCount = getQuantity
          const bookData = []
          const promoData = []
          const descProds = sortProdsByPrice(prodDatas, pbInfo, isExc, true)
          descProds.map(qq => {
            if (spendPrice > 0) {
              const checkKey = bookContainKeys.filter(bn => bn == qq.key)
              if (checkKey && checkKey.length == 0) {
                let existProds = []
                if (!isPromoAll) {
                  const _1_prodExist = promoCheckProdSuccess(
                    condProds,
                    qq.identityInfo,
                    false
                  )
                  // const checkIfAv =
                  //   condProds && condProds.length > 0
                  //     ? condProds.filter(
                  //         r =>
                  //           getDecryptID(r.productID) ==
                  //           getDecryptID(qq.sProductID)
                  //       )
                  //     : []
                  if (_1_prodExist) {
                    // checkIfAv && checkIfAv.length > 0
                    existProds.push(qq)
                    // existProds = descProds.filter(
                    //   ss =>
                    //     getDecryptID(ss.sProductID) ==
                    //     getDecryptID(checkIfAv[0].productID)
                    // )
                  }
                } else existProds.push(qq)

                if (existProds && existProds.length > 0) {
                  let testPrice = spend
                  existProds.map(xc => {
                    bookContainKeys.push(xc.key)
                    if (testPrice > 0) {
                      // let loopCheckPrice = spendPrice;
                      const bukQuantity = xc.bookkQuantity
                        ? xc.bookkQuantity
                        : 0
                      const proQuantity = xc.pormQuant ? xc.pormQuant : 0
                      const composite = bukQuantity + proQuantity
                      const quantity = xc.displayQuantity - composite
                      if (quantity > 0) {
                        let considerrQuant = 0
                        let considerrPrice = 0
                        for (let j = 1; j <= quantity; j++) {
                          const pprice = isExc
                            ? xc.bestPriceBookInfo.price
                            : xc.bestPriceBookInfo.price +
                              xc.bestPriceBookInfo.tax
                          const actualPrice = pprice * j
                          let loopCheckPrice = testPrice
                          loopCheckPrice -= actualPrice
                          considerrQuant = j
                          considerrPrice = loopCheckPrice
                          if (loopCheckPrice <= 0) {
                            spendPrice = 0
                            // bookData.push({ key: xc.key, value: j });
                            // existProds.map(gg => {
                            //   bookData.push({ key: gg.key, value: gg.displayQuantity });
                            // });
                            break
                          }
                        }
                        testPrice = considerrPrice
                        bookData.push({ key: xc.key, value: considerrQuant })
                      }
                    }
                  })
                }
              }
            }
          })
          if (bookData && bookData.length > 0) {
            descProds.map(qw => {
              const condMet = bookData.filter(x => x.key == qw.key)
              if (condMet && condMet.length > 0) {
                qw.bookkQuantity = qw.bookkQuantity ? qw.bookkQuantity : 0
                qw.bookkQuantity += condMet[0].value
              }
            })

            /// checking if promo apply prod quantity is available
            const ascProds = sortProdsByPrice(descProds, pbInfo, isExc, false)
            const existKeys = []
            ascProds.map(a => {
              const checkIfExist = existKeys.filter(tt => tt == a.key)
              if (checkIfExist && checkIfExist.length == 0) {
                let existInCond = []
                if (!isGetAll) {
                  existInCond =
                    rewardProds && rewardProds.length > 0
                      ? rewardProds.filter(
                          b =>
                            getDecryptID(b.productID) ==
                            getDecryptID(a.sProductID)
                        )
                      : []
                  if (existInCond && existInCond.length > 0) {
                    existInCond = ascProds.filter(
                      qq =>
                        getDecryptID(qq.sProductID) ==
                        getDecryptID(existInCond[0].productID)
                    )
                  }
                } else {
                  existInCond.push(a)
                }
                if (existInCond && existInCond.length > 0) {
                  if (getCount > 0) {
                    existInCond.map(c => {
                      existKeys.push(c.key)
                      if (getCount > 0) {
                        let promoQuantity = 0
                        let promoKey = c.key ? c.key : 0
                        let shallowBuyCount = getCount
                        const bookQuantity = c.bookkQuantity
                          ? c.bookkQuantity
                          : 0
                        const promoQuant = c.pormQuant ? c.pormQuant : 0
                        const considerQuantum = bookQuantity + promoQuant
                        const quantity = c.displayQuantity - considerQuantum
                        if (quantity > 0) {
                          getCount -= quantity
                          if (getCount < 0) {
                            promoQuantity += shallowBuyCount
                            const prodData = {
                              key: promoKey,
                              value: promoQuantity
                            }
                            promoData.push(prodData)
                          } else {
                            promoQuantity += quantity
                            const prodData = {
                              key: promoKey,
                              value: promoQuantity
                            }
                            promoData.push(prodData)
                          }
                        }
                      }
                    })
                  }
                }
              }
            })

            //check if get count met & promo is applicable
            if (getCount <= 0) {
              ascProds.map(a => {
                const condMet = promoData.filter(x => x.key == a.key)
                if (condMet && condMet.length > 0) {
                  a.pormQuant = a.pormQuant ? a.pormQuant : 0
                  a.pormQuant += condMet[0].value
                }
              })

              // adding in recheck count
              jackCount++
            } else proceed = false

            // replacing nominates with edited version of bookquantity and promo apply quantity
            prodDatas = ascProds
          } else proceed = false
        }
      }

      if (jackCount != count) {
        count = jackCount
      }

      nominates.map(n => {
        n.bookkQuantity = 0
        n.pormQuant = 0
      })

      //NOTE:
      //There is a slight change for the spend scenario times calculation
      //we are noticing price with the quantity but we should change this approach
      //to the condition like where we watch spend money and then take accumalative amount then divide it by the spend amount
      //like if spend amount is 250 and 2 products making the amount greater than 1000
      //then the given reward quantity should be multiply the times by the 250 is meeting in those 2 prods
      //like if 2 prods crossing the amount of 1000 and spend condition is 250 && reward quantity is 2
      //then reward quantity becomes 4 times --> 8 prods will be rewarded...!!!
    }
  }
  return count
}

export function sortProdsByPrice (prods, pbInfo, isExc, isDesc) {
  if (prods && prods.length > 0) {
    prods.sort(function (a, b) {
      let aa = 0
      let bb = 0
      const incomingPrice = isExc ? pbInfo.price : pbInfo.price + pbInfo.tax
      if (a.incoming) {
        aa = incomingPrice
      } else {
        aa = isExc
          ? a.bestPriceBookInfo.price
          : a.bestPriceBookInfo.price + a.bestPriceBookInfo.tax
      }

      if (b.incoming) {
        bb = incomingPrice
      } else {
        bb = isExc
          ? b.bestPriceBookInfo.price
          : b.bestPriceBookInfo.price + b.bestPriceBookInfo.tax
      }
      return isDesc ? bb - aa : aa - bb
    })
  }
  return prods
}

export function sortSameProdsByQuantity (prods, isDesc) {
  if (prods && prods.length > 0) {
    prods.sort(function (a, b) {
      const aa = a.displayQuantity
      const bb = b.displayQuantity
      return isDesc ? bb - aa : aa - bb
    })
  }
  return prods
}

export function calculateSaveEntireAmount (
  prod,
  prods,
  entireDisc,
  bestPriceBookInfo,
  incomingPrice
) {
  let result = entireDisc ? entireDisc : 0
  if (prod && prods && prods.length > 0) {
    let subtotal = bestPriceBookInfo.price
      ? bestPriceBookInfo.price * prod.displayQuantity
      : 0
    const incomeKey = prod.key ? prod.key : 0
    prods.map(a => {
      const price =
        a.bestPriceBookInfo && a.bestPriceBookInfo.price
          ? a.bestPriceBookInfo.price * a.displayQuantity
          : 0
      subtotal += a.key && a.key != incomeKey ? price : 0
    })

    if (subtotal && result && incomingPrice) {
      const discPer = result / subtotal
      const deduct = incomingPrice * discPer
      result = deduct
    }
  }
  return result
}

export function arrayForPayFix (
  prod,
  prods,
  bestPriceBookInfo,
  fixPrice,
  buyQuantity,
  condProds,
  isExc,
  isPromoAll
) {
  const result = {
    finalProds: [],
    buyTotal: 0,
    fixPriceTotal: 0
  }
  const finalProds = []
  let buyTotalQuantity = 0
  let payTotalFix = 0
  if (prod && prods && prods.length > 0 && fixPrice && buyQuantity) {
    if (isPromoAll || (condProds && condProds.length > 0)) {
      // prods present in buy condition
      const nominatedProds = getNominatedProds(
        condProds,
        prod,
        prods,
        isPromoAll
      )
      if (nominatedProds && nominatedProds.length > 0) {
        const identifyTimes = promoApplyTimes(
          nominatedProds,
          buyQuantity,
          false
        )
        payTotalFix = identifyTimes * fixPrice
        buyTotalQuantity = identifyTimes * buyQuantity

        // order by price ascending
        const orderAsc = sortProdsByPrice(
          nominatedProds,
          bestPriceBookInfo,
          isExc,
          false
        )
        let buyTotal = buyTotalQuantity
        // buy quantity's condition meeting prods
        for (let i = 0; i < buyTotalQuantity; i++) {
          if (buyTotal > 0) {
            const finalProd = orderAsc[i]
            if (finalProd && !isEmptyObject(finalProd)) {
              finalProd.promoIndex = i
              buyTotal -= finalProd.displayQuantity
              finalProds.push(finalProd)
            }
          }
        }
      }
    }
  }
  result.finalProds = finalProds
  result.buyTotal = buyTotalQuantity
  result.fixPriceTotal = payTotalFix
  return result
}

export function calculatePayFix (
  finalProds,
  bestPriceBookInfo,
  isExc,
  buyTotal,
  fixPriceTotal,
  incomingProdIndex
) {
  let result = 0
  let quantity = buyTotal
  let prodNominatedTotal = 0
  if (finalProds && finalProds.length > 0) {
    // calculating prodNominated subTotal from incoming nominated prods to the point where prod quantity meets buyTotal quantity
    finalProds.map(a => {
      let calQuantity = a.displayQuantity
      let observedQuantity = quantity
      observedQuantity -= calQuantity
      if (observedQuantity < 0) {
        calQuantity = quantity
        observedQuantity = 0
      }
      if (observedQuantity >= 0) {
        quantity -= calQuantity
        if (a.incoming) {
          const price = isExc
            ? bestPriceBookInfo.price
            : bestPriceBookInfo.price + bestPriceBookInfo.tax
          prodNominatedTotal += price * calQuantity
        } else {
          const pricee = isExc
            ? a.bestPriceBookInfo.price
            : a.bestPriceBookInfo.price + a.bestPriceBookInfo.tax
          prodNominatedTotal += pricee * calQuantity
        }
        a.promoCalQuantity = calQuantity
      }
    })

    // calculating incoming prod subtract promo Amount
    let incomingSubtotal = 0
    const incomProd = finalProds.filter(a => a.promoIndex == incomingProdIndex)
    if (incomProd && incomProd.length > 0) {
      const pprice = isExc
        ? incomProd[0].bestPriceBookInfo.price
        : incomProd[0].bestPriceBookInfo.price +
          incomProd[0].bestPriceBookInfo.tax
      incomingSubtotal += pprice * incomProd[0].promoCalQuantity
    }

    if (incomingSubtotal) {
      const promoAmount = prodNominatedTotal - fixPriceTotal
      result = (incomingSubtotal / prodNominatedTotal) * promoAmount
    }
  }
  return result
}

export function promoApplyTimes (nominatedProds, buy, spend) {
  let times = 0
  // identifying how many times the promo will apply (buy cond meet how many times)
  if (nominatedProds && nominatedProds.length > 0) {
    if (buy) {
      let totalNominatedQuantity = 0
      nominatedProds.map(x => {
        totalNominatedQuantity += x.displayQuantity
      })
      times = Math.floor(totalNominatedQuantity / buy)
    } else if (spend) {
      // for checking spend amount
    }
  }
  return times
}

// export function promoApplyGetTimes(descProds, buy, spend, condProds, isPromoAll) {
//   let times = 0;
//   // identifying how many times the promo will apply (buy cond meet how many times)
//   if (descProds && descProds.length > 0) {
//     if (buy) {
//       descProds.map(a => {
//         let existInCond = [];
//         if (!isPromoAll) {
//           existInCond = condProds && condProds.length > 0 ?
//             condProds.filter(b => getDecryptID(b.productID) == getDecryptID(a.sProductID)) :
//             [];
//           if (existInCond && existInCond.length > 0) {
//             existInCond = descProds.filter(qq => getDecryptID(qq.sProductID) == getDecryptID(existInCond[0].productID));
//           }
//         } else {
//           existInCond.push(a);
//         }
//         if (existInCond && existInCond.length > 0) {
//           if (buyTimes) {
//             if (buyCount > 0) {
//               let bookQuantity = 0;
//               existInCond.map(c => {
//                 copyBuyCount = buyCount;
//                 buyCount -= c.displayQuantity
//                 if (buyCount < 0) {
//                   bookQuantity += copyBuyCount;
//                 } else {
//                   bookQuantity += c.displayQuantity;
//                 }
//               });
//               a.bookQuantity = bookQuantity;
//             }
//           }
//           else if (spendTimes) {

//           }
//         }
//       });
//     }
//     else if (spend) {

//     }
//   }
//   return times;
// }

// export function promoMeetCheck(descArray, condProds, buyTimes, spendTimes, isPromoAll) {
//   const result = {
//     isAllow: false,
//     descList: [],
//   };
//   let buyCount = buyTimes;
//   const data = [];
//   descArray.map(a => {
//     let existInCond = [];
//     if (!isPromoAll) {
//       existInCond = condProds && condProds.length > 0 ?
//         condProds.filter(b => getDecryptID(b.productID) == getDecryptID(a.sProductID)) :
//         [];
//       if (existInCond && existInCond.length > 0) {
//         existInCond = descArray.filter(qq => getDecryptID(qq.sProductID) == getDecryptID(existInCond[0].productID));
//       }
//     } else {
//       existInCond.push(a);
//     }
//     if (existInCond && existInCond.length > 0) {
//       if (buyTimes) {
//         if (buyCount > 0) {
//           existInCond.map(c => {
//             if (buyCount > 0) {
//               let bookQuantity = 0;
//               let bookKey = c.key ? c.key : 0;
//               let shallowBuyCount = buyCount;
//               const bukQuantity = c.bookQuantity ? c.bookQuantity : 0;
//               const promoQuant = false ? c.promoQuantity : 0;
//               const considerQuantum = bukQuantity + promoQuant;
//               const quantity = c.displayQuantity - considerQuantum;
//               if (quantity > 0) {
//                 buyCount -= quantity;
//                 if (buyCount < 0) {
//                   bookQuantity += shallowBuyCount;
//                   const prodData = { key: bookKey, value: bookQuantity };
//                   data.push(prodData);
//                 } else {
//                   bookQuantity += quantity;
//                   const prodData = { key: bookKey, value: bookQuantity };
//                   data.push(prodData);
//                 }
//               }
//             }
//           });
//         }
//       }
//       else if (spendTimes) {

//       }
//     }
//   });

//   //check if buy count is applicable
//   if (buyCount <= 0) {
//     descArray.map(a => {
//       const condMet = data.filter(x => x.key == a.key);
//       if (condMet && condMet.length > 0) {
//         a.bookQuantity = a.bookQuantity ? a.bookQuantity : 0;
//         a.bookQuantity += condMet[0].value;
//       }
//     });
//     result.isAllow = true;
//     result.descList = descArray;
//   }

//   return result;
// }

export function promoMeetCheck (
  descArray,
  condProds,
  buyTimes,
  spendTimes,
  isPromoAll,
  times,
  isExc
) {
  const result = {
    isAllow: false,
    descList: []
  }
  let buyCount = buyTimes * times
  let spendCount = spendTimes * times
  const data = []
  const existKeys = []
  descArray.map(a => {
    const checkIfExist = existKeys.filter(tt => tt == a.key)
    if (checkIfExist && checkIfExist.length == 0) {
      let existInCond = []
      if (!isPromoAll) {
        let prodExist = false
        if (condProds && condProds.length > 0) {
          prodExist = promoCheckProdSuccess(condProds, a.identityInfo, false)
        }

        // existInCond =
        //   condProds && condProds.length > 0
        //     ? condProds.filter(
        //         b => getDecryptID(b.productID) == getDecryptID(a.sProductID)
        //       )
        //     : []
        if (prodExist) {
          // existInCond && existInCond.length > 0
          existInCond = descArray.filter(
            qq => getDecryptID(qq.sProductID) == getDecryptID(a.sProductID)
          )
          // existInCond = descArray.filter(
          //   qq =>
          //     getDecryptID(qq.sProductID) ==
          //     getDecryptID(existInCond[0].productID)
          // )
        }
      } else {
        existInCond.push(a)
      }
      if (existInCond && existInCond.length > 0) {
        if (buyTimes) {
          if (buyCount > 0) {
            existInCond.map(c => {
              existKeys.push(c.key)
              if (buyCount > 0) {
                let bookQuantity = 0
                let bookKey = c.key ? c.key : 0
                let shallowBuyCount = buyCount
                const bukQuantity = c.bookQuantity ? c.bookQuantity : 0
                const promoQuant = c.promoQuantity ? c.promoQuantity : 0
                const considerQuantum = bukQuantity + promoQuant
                const quantity = c.displayQuantity - considerQuantum
                if (quantity > 0) {
                  buyCount -= quantity
                  if (buyCount < 0) {
                    bookQuantity += shallowBuyCount
                    const prodData = { key: bookKey, value: bookQuantity }
                    data.push(prodData)
                  } else {
                    bookQuantity += quantity
                    const prodData = { key: bookKey, value: bookQuantity }
                    data.push(prodData)
                  }
                }
              }
            })
          }
        } else if (spendTimes) {
          if (spendCount > 0) {
            existInCond.map(c => {
              if (spendCount > 0) {
                let bookQuantity = 0
                let bookKey = c.key ? c.key : 0
                // let shallowBuyCount = spendCount;
                const bukQuantity = c.bookQuantity ? c.bookQuantity : 0
                const promoQuant = c.promoQuantity ? c.promoQuantity : 0
                const considerQuantum = bukQuantity + promoQuant
                const quantity = c.displayQuantity - considerQuantum
                const price = isExc
                  ? c.bestPriceBookInfo.price
                  : c.bestPriceBookInfo.price + c.bestPriceBookInfo.tax
                let checkPrice = 0
                let toConsiderQuantity = 0
                for (var i = 1; i <= quantity; i++) {
                  checkPrice = price * i
                  bookQuantity = i
                  if (checkPrice >= spendCount) {
                    // toConsiderQuantity = i;
                    break
                  }
                }
                spendCount -= checkPrice
                const prodData = { key: bookKey, value: bookQuantity }
                data.push(prodData)
                // if (toConsiderQuantity > 0) {
                //   spendCount -= checkPrice;
                //   bookQuantity += toConsiderQuantity;
                //   const prodData = { key: bookKey, value: bookQuantity };
                //   data.push(prodData);
                // }
              }
            })
          }
        }
      }
    }
  })

  //check if buy count is applicable
  if (buyTimes) {
    if (buyCount <= 0) {
      descArray.map(a => {
        const condMet = data.filter(x => x.key == a.key)
        if (condMet && condMet.length > 0) {
          a.bookQuantity = a.bookQuantity ? a.bookQuantity : 0
          a.bookQuantity += condMet[0].value
        }
      })
      result.isAllow = true
      result.descList = descArray
    }
  } else if (spendTimes) {
    if (spendCount <= 0) {
      descArray.map(a => {
        const condMet = data.filter(x => x.key == a.key)
        if (condMet && condMet.length > 0) {
          a.bookQuantity = a.bookQuantity ? a.bookQuantity : 0
          a.bookQuantity += condMet[0].value
        }
      })
      result.isAllow = true
      result.descList = descArray
    }
  }

  return result
}

export function promoApplicableCheck (
  ascArray,
  getQuantity,
  rewardProds,
  isGetAll,
  times
) {
  let ascList = []
  let getCount = getQuantity * times
  const data = []
  const existKeys = []
  ascArray.map(a => {
    const checkIfExist = existKeys.filter(tt => tt == a.key)
    if (checkIfExist && checkIfExist.length == 0) {
      let existInCond = []
      if (!isGetAll) {
        existInCond =
          rewardProds && rewardProds.length > 0
            ? rewardProds.filter(
                b => getDecryptID(b.productID) == getDecryptID(a.sProductID)
              )
            : []
        if (existInCond && existInCond.length > 0) {
          existInCond = ascArray.filter(
            qq =>
              getDecryptID(qq.sProductID) ==
              getDecryptID(existInCond[0].productID)
          )
        }
      } else {
        existInCond.push(a)
      }
      if (existInCond && existInCond.length > 0) {
        if (getCount > 0) {
          existInCond.map(c => {
            existKeys.push(c.key)
            if (getCount > 0) {
              let promoQuantity = 0
              let promoKey = c.key ? c.key : 0
              let shallowBuyCount = getCount
              const bookQuantity = c.bookQuantity ? c.bookQuantity : 0
              const promoQuant = c.promoQuantity ? c.promoQuantity : 0
              const considerQuantum = bookQuantity + promoQuant
              const quantity = c.displayQuantity - considerQuantum
              if (quantity > 0) {
                getCount -= quantity
                if (getCount < 0) {
                  promoQuantity += shallowBuyCount
                  const prodData = {
                    key: promoKey,
                    value: promoQuantity,
                    name: c.productName
                  }
                  data.push(prodData)
                } else {
                  promoQuantity += quantity
                  const prodData = {
                    key: promoKey,
                    value: promoQuantity,
                    name: c.productName
                  }
                  data.push(prodData)
                }
              }
            }
          })
        }
      }
    }
  })

  //check if get count met & promo is applicable
  if (getCount <= 0) {
    const finalProds = []
    ascArray.map(a => {
      const condMet = data.filter(x => x.key == a.key)
      if (condMet && condMet.length > 0) {
        a.promoQuantity = a.promoQuantity ? a.promoQuantity : 0
        a.promoQuantity += condMet[0].value
        finalProds.push(a)
      }
    })
    ascList = finalProds
  }

  return ascList
}

// export function promoApplicableCheck(ascArray, getQuantity, rewardProds, isGetAll, times) {
//   let ascList = [];
//   let getCount = getQuantity;
//   const data = [];
//   ascArray.map(a => {
//     let existInCond = [];
//     if (!isGetAll) {
//       existInCond = rewardProds && rewardProds.length > 0 ?
//         rewardProds.filter(b => getDecryptID(b.productID) == getDecryptID(a.sProductID)) :
//         [];
//       if (existInCond && existInCond.length > 0) {
//         existInCond = ascArray.filter(qq => getDecryptID(qq.sProductID) == getDecryptID(existInCond[0].productID));
//       }
//     } else {
//       existInCond.push(a);
//     }
//     if (existInCond && existInCond.length > 0) {
//       if (getCount > 0) {
//         existInCond.map(c => {
//           if (getCount > 0) {
//             let promoQuantity = 0;
//             let promoKey = c.key ? c.key : 0;
//             let shallowBuyCount = getCount;
//             const bookQuantity = c.bookQuantity ? c.bookQuantity : 0;
//             const promoQuant = c.promoQuantity ? c.promoQuantity : 0;
//             const considerQuantum = bookQuantity + promoQuant;
//             const quantity = c.displayQuantity - considerQuantum;
//             if (quantity > 0) {
//               getCount -= quantity;
//               if (getCount < 0) {
//                 promoQuantity += shallowBuyCount;
//                 const prodData = { key: promoKey, value: promoQuantity };
//                 data.push(prodData);
//               } else {
//                 promoQuantity += quantity;
//                 const prodData = { key: promoKey, value: promoQuantity };
//                 data.push(prodData);
//               }
//             }
//           }
//         });
//       }
//     }
//   });

//   //check if get count met & promo is applicable
//   if (getCount <= 0) {
//     const finalProds = [];
//     ascArray.map(a => {
//       const condMet = data.filter(x => x.key == a.key);
//       if (condMet && condMet.length > 0) {
//         a.promoQuantity = a.promoQuantity ? a.promoQuantity : 0;
//         a.promoQuantity += condMet[0].value;
//         finalProds.push(a);
//       }
//     });
//     ascList = finalProds;
//   }

//   return ascList;
// }

// export function getItemsNominated(
//   prod,
//   prods,
//   bestPriceBookInfo,
//   condProds,
//   rewardProds,
//   buy,
//   spend,
//   getQuantity,
//   isGetAll,
//   isPromoAll,
//   isExc,
//   type,
// ) {
//   let result = [];
//   if (prod && prods && prods.length > 0 && getQuantity) {
//     prod.incoming = true;
//     const incomeKey = prod.key ? prod.key : 0;
//     prods = prods.filter(xx => xx.key != incomeKey); // if incoming prod already exist in list prods then eliminate it from prods list first
//     prods.push(prod);

//     //check how many times promo can apply
//     const nominated = getNominatedProds(condProds, prod, prods, isPromoAll);
//     let prodData = prods;
//     if (nominated && nominated.length > 0) {
//       const identifyTimes = promoApplyTimes(nominated, buy, spend);
//       let res = [];
//       let proceed = true;
//       for (let i = 0; i < identifyTimes; i++) {
//         if (proceed) {
//           // sorting by price desc
//           const descArray = sortProdsByPrice(prodData, bestPriceBookInfo, isExc, true);
//           if (descArray && descArray.length > 0) {
//             // marking && checking promo cond meet quantity or spend amount
//             const condMeetCheck = promoMeetCheck(descArray, condProds, buy, spend, isPromoAll);
//             if (condMeetCheck && condMeetCheck.isAllow) {
//               const ascArray = sortProdsByPrice(condMeetCheck.descList, bestPriceBookInfo, isExc, false);
//               const condApplyCheck = promoApplicableCheck(ascArray, getQuantity, rewardProds, isGetAll, times);
//               res = condApplyCheck && Array.isArray(condApplyCheck) && condApplyCheck.length > 0 ? condApplyCheck : [];
//               if (result && result.length != 0) {
//                 if (res && res.length > 0) {
//                   res.map(we => {
//                     const isExist = result.filter(bb => bb.key == we.key);
//                     if (isExist && isExist.length > 0) {
//                       result = result.filter(m => m.key != we.key);
//                     }
//                     result.push(we);
//                   });
//                 } else break;
//               } else {
//                 result = res;
//               }
//               res && res.length > 0 && res.map(zx => {
//                 const nomProd = prodData.filter(vv => vv.key == zx.key);
//                 if (nomProd && nomProd.length > 0) {
//                   prodData = prodData.filter(fd => fd.key != zx.key);
//                   prodData.push(zx);
//                 }
//               });
//             }
//             else {
//               proceed = false;
//               if (result && result.length != 0) {
//                 if (res && res.length > 0) {
//                   res.map(we => {
//                     const isExist = result.filter(bb => bb.key == we.key);
//                     if (isExist && isExist.length > 0) {
//                       result = result.filter(m => m.key != we.key);
//                     }
//                     result.push(we);
//                   });
//                 }
//               } else {
//                 result = res;
//               }
//             }
//           }
//         }
//       };
//     }

//     //check prices comparison
//     if (type != "getItems_getFree") {
//       if (result && result.length > 0) {
//         let bookPrice = 0;
//         let promoPrice = 0;
//         prodData.map(a => {
//           const quantity = a.bookQuantity ? a.bookQuantity : 0;
//           if (quantity > 0) {
//             const price = isExc ? a.bestPriceBookInfo.price : a.bestPriceBookInfo.price + a.bestPriceBookInfo.tax;
//             bookPrice += price * quantity;
//           }
//         });

//         result.map(b => {
//           const quantity = b.promoQuantity ? b.promoQuantity : 0;
//           if (quantity > 0) {
//             const price = isExc ? b.bestPriceBookInfo.price : b.bestPriceBookInfo.price + b.bestPriceBookInfo.tax;
//             promoPrice += price * quantity;
//           }
//         });

//         let diff = bookPrice - promoPrice;
//         if (diff < 0) {
//           diff *= -1;
//           if (type == "getItems_getAmount") {
//             if (diff > 200) {
//               result = [];
//             }
//           }
//           else {
//             if (diff > 10) {
//               result = [];
//             }
//           }
//         }
//       }
//     }
//   }
//   return result;
// }

export function getItemsNominated (
  prod,
  prods,
  bestPriceBookInfo,
  condProds,
  rewardProds,
  buy,
  spend,
  getQuantity,
  isGetAll,
  isPromoAll,
  isExc,
  type
) {
  let result = []
  if (prod && prods && prods.length > 0 && getQuantity) {
    prod.incoming = true
    const incomeKey = prod.key ? prod.key : 0
    prods = prods.filter(xx => xx.key != incomeKey) // if incoming prod already exist in list prods then eliminate it from prods list first
    prods.push(prod)

    //check how many times promo can apply
    const times = getImplementationCount(
      condProds,
      prod,
      prods,
      isPromoAll,
      rewardProds,
      isGetAll,
      buy,
      getQuantity,
      spend,
      isExc,
      bestPriceBookInfo
    )
    let prodData = prods
    if (prodData && prodData.length > 0) {
      let res = []
      let proceed = true
      // sorting by price desc
      if (buy) {
        // marking && checking promo cond meet quantity or spend amount
        const descArray = sortProdsByPrice(
          prodData,
          bestPriceBookInfo,
          isExc,
          true
        )
        const condMeetCheck = promoMeetCheck(
          descArray,
          condProds,
          buy,
          spend,
          isPromoAll,
          times,
          isExc
        )
        if (condMeetCheck && condMeetCheck.isAllow) {
          const ascArray = sortProdsByPrice(
            condMeetCheck.descList,
            bestPriceBookInfo,
            isExc,
            false
          )
          const condApplyCheck = promoApplicableCheck(
            ascArray,
            getQuantity,
            rewardProds,
            isGetAll,
            times
          )
          res =
            condApplyCheck &&
            Array.isArray(condApplyCheck) &&
            condApplyCheck.length > 0
              ? condApplyCheck
              : []
          if (result && result.length != 0) {
            if (res && res.length > 0) {
              res.map(we => {
                const isExist = result.filter(bb => bb.key == we.key)
                if (isExist && isExist.length > 0) {
                  result = result.filter(m => m.key != we.key)
                }
                result.push(we)
              })
            }
          } else {
            result = res
          }
          res &&
            res.length > 0 &&
            res.map(zx => {
              const nomProd = prodData.filter(vv => vv.key == zx.key)
              if (nomProd && nomProd.length > 0) {
                prodData = prodData.filter(fd => fd.key != zx.key)
                prodData.push(zx)
              }
            })
        } else {
          if (result && result.length != 0) {
            if (res && res.length > 0) {
              res.map(we => {
                const isExist = result.filter(bb => bb.key == we.key)
                if (isExist && isExist.length > 0) {
                  result = result.filter(m => m.key != we.key)
                }
                result.push(we)
              })
            }
          } else {
            result = res
          }
        }
      } else if (spend) {
        // sorting by price desc
        const descArrayForSpend = sortProdsByPrice(
          prodData,
          bestPriceBookInfo,
          isExc,
          true
        )
        if (descArrayForSpend && descArrayForSpend.length > 0) {
          // marking && checking promo cond meet quantity or spend amount
          const condMeetCheckForSpend = promoMeetCheck(
            descArrayForSpend,
            condProds,
            buy,
            spend,
            isPromoAll,
            times,
            isExc
          )
          if (condMeetCheckForSpend && condMeetCheckForSpend.isAllow) {
            const ascArrayForSpend = sortProdsByPrice(
              condMeetCheckForSpend.descList,
              bestPriceBookInfo,
              isExc,
              false
            )
            const condApplyCheckForSpend = promoApplicableCheck(
              ascArrayForSpend,
              getQuantity,
              rewardProds,
              isGetAll,
              times
            )
            res =
              condApplyCheckForSpend &&
              Array.isArray(condApplyCheckForSpend) &&
              condApplyCheckForSpend.length > 0
                ? condApplyCheckForSpend
                : []
            if (result && result.length != 0) {
              if (res && res.length > 0) {
                res.map(we => {
                  const isExistt = result.filter(bb => bb.key == we.key)
                  if (isExistt && isExistt.length > 0) {
                    result = result.filter(m => m.key != we.key)
                  }
                  result.push(we)
                })
              }
            } else {
              result = res
            }
            res &&
              res.length > 0 &&
              res.map(zx => {
                const nomProd = prodData.filter(vv => vv.key == zx.key)
                if (nomProd && nomProd.length > 0) {
                  prodData = prodData.filter(fd => fd.key != zx.key)
                  prodData.push(zx)
                }
              })
          } else {
            if (result && result.length != 0) {
              if (res && res.length > 0) {
                res.map(we => {
                  const isExistSpend = result.filter(bb => bb.key == we.key)
                  if (isExistSpend && isExistSpend.length > 0) {
                    result = result.filter(m => m.key != we.key)
                  }
                  result.push(we)
                })
              }
            } else {
              result = res
            }
          }
        }

        // for (let i = 0; i < times; i++) {
        //   if (proceed) {
        //     // sorting by price desc
        //     const descArrayForSpend = sortProdsByPrice(prodData, bestPriceBookInfo, isExc, true);
        //     if (descArrayForSpend && descArrayForSpend.length > 0) {
        //       // marking && checking promo cond meet quantity or spend amount
        //       const condMeetCheckForSpend = promoMeetCheck(descArrayForSpend, condProds, buy, spend, isPromoAll, times, isExc);
        //       if (condMeetCheckForSpend && condMeetCheckForSpend.isAllow) {
        //         const ascArrayForSpend = sortProdsByPrice(condMeetCheckForSpend.descList, bestPriceBookInfo, isExc, false);
        //         const condApplyCheckForSpend = promoApplicableCheck(ascArrayForSpend, getQuantity, rewardProds, isGetAll, times);
        //         res = condApplyCheckForSpend && Array.isArray(condApplyCheckForSpend) &&
        //           condApplyCheckForSpend.length > 0 ? condApplyCheckForSpend : [];
        //         if (result && result.length != 0) {
        //           if (res && res.length > 0) {
        //             res.map(we => {
        //               const isExistt = result.filter(bb => bb.key == we.key);
        //               if (isExistt && isExistt.length > 0) {
        //                 result = result.filter(m => m.key != we.key);
        //               }
        //               result.push(we);
        //             });
        //           } else break;
        //         } else {
        //           result = res;
        //         }
        //         res && res.length > 0 && res.map(zx => {
        //           const nomProd = prodData.filter(vv => vv.key == zx.key);
        //           if (nomProd && nomProd.length > 0) {
        //             prodData = prodData.filter(fd => fd.key != zx.key);
        //             prodData.push(zx);
        //           }
        //         });
        //       }
        //       else {
        //         proceed = false;
        //         if (result && result.length != 0) {
        //           if (res && res.length > 0) {
        //             res.map(we => {
        //               const isExistSpend = result.filter(bb => bb.key == we.key);
        //               if (isExistSpend && isExistSpend.length > 0) {
        //                 result = result.filter(m => m.key != we.key);
        //               }
        //               result.push(we);
        //             });
        //           }
        //         } else {
        //           result = res;
        //         }
        //       }
        //     }
        //   }
        // };
      }
    }

    //check prices comparison
    if (type != 'getItems_getFree') {
      if (result && result.length > 0) {
        let bookPrice = 0
        let promoPrice = 0
        prodData.map(a => {
          const quantity = a.bookQuantity ? a.bookQuantity : 0
          if (quantity > 0) {
            const price = isExc
              ? a.bestPriceBookInfo.price
              : a.bestPriceBookInfo.price + a.bestPriceBookInfo.tax
            bookPrice += price * quantity
          }
        })

        result.map(b => {
          const quantity = b.promoQuantity ? b.promoQuantity : 0
          if (quantity > 0) {
            const price = isExc
              ? b.bestPriceBookInfo.price
              : b.bestPriceBookInfo.price + b.bestPriceBookInfo.tax
            promoPrice += price * quantity
          }
        })

        let diff = bookPrice - promoPrice
        if (buy) {
          if (diff < 0) {
            diff *= -1
            if (type == 'getItems_getAmount') {
              const checkAmountForAmount = 200 * times
              if (diff > checkAmountForAmount) {
                result = []
              }
            } else {
              const checkAmountTwo = 10 * times
              if (diff > checkAmountTwo) {
                result = []
              }
            }
          }
        } else if (spend) {
          // spend prices check condition here
        }
      }
    }
  }
  return result
}

export function calculatePromoGetItems (
  type,
  price,
  percent,
  amount,
  prodQuantity,
  promoQuantity
) {
  let result = 0
  if (type && price) {
    if (type == 'getItems_getFree') {
      price *= promoQuantity
      result = price
    } else if (type == 'getItems_getPercent') {
      price *= promoQuantity
      result = price * (percent / 100)
    } else if (type == 'getItems_getAmount') {
      price *= promoQuantity
      amount *= promoQuantity
      result = price - amount
      if (result < 0) {
        result = price
      } else result = amount
    }
  }
  return result
}

export function resetBookPromoQuantity (prod, prods) {
  if (prod.bookQuantity) {
    prod.bookQuantity = 0
  }
  if (prod.promoQuantity) {
    prod.promoQuantity = 0
  }
  prods &&
    prods.length > 0 &&
    prods.map(a => {
      if (a.bookQuantity) {
        a.bookQuantity = 0
      }
      if (a.promoQuantity) {
        a.promoQuantity = 0
      }
    })
}

export function checkIfPromoExist (prod, prodList, promoList, promoName) {
  const result = []
  let toConsider = prodList
  if (prod && toConsider && toConsider.length > 0) {
    prod.incoming = true
    const incomeKey = prod.key ? prod.key : 0
    toConsider = toConsider.filter(xx => xx.key != incomeKey) // if incoming prod already exist in list prods then eliminate it from prods list first
    toConsider.push(prod)

    if (promoName && promoList && promoList.length > 0) {
      promoList &&
        promoList.length > 0 &&
        promoList.map(a => {
          toConsider = toConsider.filter(x => x.key != a.key)
        })
    }

    toConsider &&
      toConsider.length > 0 &&
      toConsider.map(ee => {
        if (
          ee.PromotionandPriceBookDetails &&
          ee.PromotionandPriceBookDetails.AppliedPromotionDetails &&
          ee.PromotionandPriceBookDetails.AppliedPromotionDetails.length > 0 &&
          ee.PromotionandPriceBookDetails.AppliedPromotionDetails[0].name ==
            promoName
        ) {
          result.push(ee)
        }
      })
  }
  return result
}

export function checkPasswordStrength (pass) {
  let result = '1'
  if (pass) {
    //checking length
    if (pass.length < 8) {
      result = '2'
      return result
    }
    //checking space in string
    if (/\s/g.test(pass)) {
      result = '7'
      return result
    }
    //checking at least 1 small case character
    if (!/[a-z]/.test(pass)) {
      result = '3'
      return result
    }
    //checking at least 1 upper case character
    if (!/[A-Z]/.test(pass)) {
      result = '4'
      return result
    }
    //checking at least 1 special character
    if (!/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(pass)) {
      result = '5'
      return result
    }
    //checking at least 1 numeric character
    if (!/\d/.test(pass)) {
      result = '6'
      return result
    }
  }
  return result
}

export function fetchTackStatus (id) {
  let result = 'NILL'
  if (id) {
    result =
      SALE_TRACKING.filter(a => a.ID == getDecryptID(id)).length > 0
        ? SALE_TRACKING.filter(a => a.ID == getDecryptID(id))[0].NAME
        : ''
  }
  return result
}

export function calculateRevBasedTax (percent, fixed, price, quantity) {
  let quant = quantity ? quantity : 1
  let result = 0
  if (percent) result += price * percent
  if (fixed) result += fixed * quant
  return result
}

export function getExcPriceFromInc (taxRate, totalPrice) {
  let result = 0
  if (totalPrice) {
    result = totalPrice
    if (taxRate > 0) {
      const percent = taxRate + 1
      const tax = (totalPrice / percent) * taxRate
      result = totalPrice - tax
    }
  }
  return result
}

export function getNotificationHeader (dispatch, header, time, type, desc) {
  if (type) {
    if (type == 'success') {
      dispatch(loadNotificationBGColor('#1abc9c')) // green
    } else if (type == 'error') {
      dispatch(loadNotificationBGColor('#d62963')) // red
    } else if (type == 'warning') {
      dispatch(loadNotificationBGColor('#f59c2f')) // orange
    } else if (type == 'info') {
      dispatch(loadNotificationBGColor('#3896e8')) // blue
    }
  }
  dispatch(loadNotificationBar(true))
  dispatch(loadNotificationHead(header))
  setTimeout(() => {
    dispatch(loadNotificationBar(false))
    dispatch(loadNotificationHead('#858283')) // gray
  }, time)
}

export function closingNumPad (dispatch) {
  dispatch(loadShowNumPad(false))
  dispatch(loadShowNumPadForDiscount(false))
  dispatch(loadShowNumPadForPay(false))
  dispatch(loadNumPadType(0))
  dispatch(loadNumRelateData({}))
  dispatch(loadNumChange(0))
}

export function closeAttribModal (dispatch, dropDownStates) {
  dispatch(loadIsShowSellAttribute(false))
  let updatedStates = dropDownStates
  for (let i = 0; i < dropDownStates.length; i++) {
    dropDownStates[i] = false
  }
  dispatch(loadDropDownStates(updatedStates))
  // dispatch(loadShowAttribDrop(showAttribDrop + 1))
}

export function closeAttribTabsModal (dispatch, dropDownStates) {
  dispatch(loadSellAttribTabs(false))
  dispatch(loadSellAttribTabs_type(0))
  let updatedStates = dropDownStates
  for (let i = 0; i < dropDownStates.length; i++) {
    dropDownStates[i] = false
  }
  dispatch(loadDropDownStates(updatedStates))
  // dispatch(loadShowAttribDrop(showAttribDrop + 1))
}

export function checkForDuplicateTab () {
  var currentUrl = window.location.href
  var tabs = window.opener ? window.opener.window.frames : window.frames
  for (var i = 0; i < tabs.length; i++) {
    try {
      var tabUrl = tabs[i].location.href
      if (tabUrl === currentUrl) {
        tabs[i].focus()
        window.close()
        return true
      }
    } catch (e) {}
  }
  return false
}
export const isEmailValid = (rule, value, callback) => {
  let email = value
  if (email && email != '') {
    let reg = new RegExp('[a-z0-9]+@[a-z]+.[a-z]{2,3}')
    if (reg.test(email)) {
      let body = {
        Email: value
      }

      const isEmailValid = ds.emailDomainVerification(body, BEHAVIOUR_TYPE.POST)
      isEmailValid
        .then(response => {
          const data = response.data
          if (data.data) {
            callback()
          } else {
            callback(data.msgCode)
          }
        })
        .catch(e => {
          callback('Api error.')
        })
    } else {
      callback('Please enter a valid email address.')
    }
  } else {
    callback()
  }
}

export const non_net_redirect = (history, isNetOff) => {
  if (
    non_auth_list.filter(a =>
      window.location.pathname.toLocaleLowerCase().includes(a)
    ).length == 0
  ) {
    if (isNetOff) {
      history.push('/dashboard/sell/mainsale/webregister')
    }
  }
}

export const getIndexForKey = key => {
  let result = null
  if (key) {
    const keys = Object.values(INDEX_DB_TABLES)
    result = keys.indexOf(key)
  }
  return result
}

export const paymentDoneCall = (
  res,
  getCurrentSalesOrderStatusID,
  getEarnedLoyalty,
  getCustomerSearchData,
  body,
  getStorePaymentTypes,
  getDefaultDecimalPlaces,
  getIsRefundSale,
  returnStoreCredit,
  getIsLoyaltyEnabled,
  getIsStoreCreditEnabled,
  dispatch
) => {
  if (res) {
    //if account sale's payment done
    if (res.alreadyCompleted) {
      message.info('Sale has already been completed', 4)
    }
    if (
      getDecryptID(getCurrentSalesOrderStatusID) == '1' ||
      getDecryptID(getCurrentSalesOrderStatusID) == '2'
    ) {
      let customerData = getCustomerSearchData
      if (customerData && !isEmptyObject(customerData)) {
        const toCut = body.PaymentAmount
          ? body.PaymentAmount
          : body.paymentAmount
          ? body.paymentAmount
          : 0
        const cusAccCredit = customerData.accountCredit
          ? customerData.accountCredit
          : 0
        const resValue = cusAccCredit - toCut
        customerData.accountCredit = resValue < 0 ? 0 : resValue
      }
      ApplyCustomerAccountDetails(
        dispatch,
        customerData,
        getStorePaymentTypes,
        getDefaultDecimalPlaces,
        getIsRefundSale,
        returnStoreCredit,
        getIsLoyaltyEnabled,
        getIsStoreCreditEnabled
      )
    }
    // if (getDecryptID(getCurrentSalesOrderStatusID) == "1" || getDecryptID(getCurrentSalesOrderStatusID) == "2") {
    //   let customerData = getCustomerSearchData;
    //   const customer = onAccLayBySaleEffects( // this effect only accCredit of customer
    //     customerData,
    //     getAccLaybyCreditAmount,
    //     formAmountToPay,
    //     false,
    //     dispatch,
    //   );
    //   if (customer && !isEmptyObject(customer)) {
    //     customerData = customer;
    //   }
    //   ApplyCustomerAccountDetails(
    //     dispatch,
    //     customerData,
    //     getStorePaymentTypes,
    //     getDefaultDecimalPlaces,
    //     getIsRefundSale,
    //     returnStoreCredit,
    //     getIsLoyaltyEnabled,
    //     getIsStoreCreditEnabled,
    //   );
    // }
    dispatch(loadPaymentStatusData(res))
    dispatch(loadIsShowCompleteSale(true)) // to catch data on sell screen
    if (res.earnedLoyalty > 0) {
      dispatch(loadEarnedLoyalty(getEarnedLoyalty + res.earnedLoyalty))
    } else {
      dispatch(loadEarnedLoyalty(0))
    }
  }
}

export const indexUpdateAllPaid = indexKey => {
  if (indexKey) {
    const data = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
    data
      .then(e => {
        const saleExist = e.filter(er => er.indexKey == indexKey)
        if (saleExist && saleExist.length > 0) {
          let sale = { ...saleExist[0] }
          sale.isAllPaid = true
          saveEntitiesDatatoIndexBD(
            [sale],
            INDEX_DB_NAME,
            CURRENT_VERSION,
            INDEX_DB_TABLES.SALES,
            'indexUpdateAllPaid'
          )
        }
      })
      .catch(e => {
        console.log('INDEX_DB -> indexUpdateAllPaid -->', e)
      })
  }
}

export const indexUpdateCustomer = (indexKey, cusBody) => {
  if (indexKey) {
    const data = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
    data
      .then(e => {
        const saleExist = e.filter(er => er.indexKey == indexKey)
        if (saleExist && saleExist.length > 0) {
          let sale = { ...saleExist[0] }
          sale.customer = cusBody
          saveEntitiesDatatoIndexBD(
            [sale],
            INDEX_DB_NAME,
            CURRENT_VERSION,
            INDEX_DB_TABLES.SALES,
            'indexUpdateCustomer'
          )
        }
      })
      .catch(e => {
        console.error('INDEX_DB -> indexUpdateCustomer -->', e)
      })
  }
}

export function putIndexSalePaymentInProgress (saleBody, payBody, callFrom) {
  const indexKey = saleBody && saleBody.indexKey ? saleBody.indexKey : false
  if (indexKey) {
    const data = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
    data
      .then(e => {
        const saleExist = e.filter(er => er.indexKey == indexKey)
        if (saleExist && saleExist.length > 0) {
          let sale = { ...saleExist[0] }
          let pays =
            sale.payments && sale.payments.length > 0 ? sale.payments : []
          pays.push({
            sPaymentTypeID: payBody.paymentTypeID,
            paymentName: payBody.gateway,
            amount: payBody.amount,
            paymentOn: moment(payBody.paymentOn).toISOString(),
            paymentOnShort: payBody.paymentOnShort
          })
          saleBody.payments = pays
          manageIndexedCartJson(
            saleBody,
            true,
            false,
            false,
            `${callFrom} --> putIndexSalePaymentInProgress`
          )
          // saveEntitiesDatatoIndexBD(
          //   [sale],
          //   INDEX_DB_NAME,
          //   CURRENT_VERSION,
          //   INDEX_DB_TABLES.SALES,
          //   'putIndexSalePaymentInProgress'
          // )
        }
      })
      .catch(e => {
        console.log('INDEX_DB -> putIndexSalePaymentInProgress -->', e)
      })
  }
}

export function getEncryptedID (id) {
  let result = ''
  if (id) {
    result =
      isString(id) && id.includes('&')
        ? id
        : `${id}&&_9efa-1ea9-4faf-88ed-a48e${id}b46643`
  }
  return result
}

export const storeCreatePayload = async (indexKey, body, receipt_code) => {
  if (indexKey) {
    const data = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
    data
      .then(async e => {
        const saleExist = e.filter(er => er.indexKey == indexKey)
        if (saleExist && saleExist.length > 0) {
          let sale = { ...saleExist[0] }
          body.receiptCode = receipt_code
          sale.createBody = body
          sale.isOffline = true
          if (!sale.receiptCode) sale.receiptCode = receipt_code
          await saveEntitiesDatatoIndexBD(
            [sale],
            INDEX_DB_NAME,
            CURRENT_VERSION,
            INDEX_DB_TABLES.SALES,
            'storeCreatePayload'
          )
        }
      })
      .catch(e => {
        console.log('INDEX_DB -> storeCreatePayload -->', e)
      })
  }
}

export const getSalesOrderID = () => {
  return localStorage.getItem('orderGuidID') &&
    localStorage.getItem('orderGuidID') != 'undefined'
    ? localStorage.getItem('orderGuidID')
    : ''
}

export async function updateSaleIndexed (key, obj) {
  const data = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
  data
    .then(async e => {
      if (obj && !isEmptyObject(obj)) {
        const saleExist = e.filter(q => q.indexKey == key)
        if (saleExist && saleExist.length > 0) {
          let sale = { ...saleExist[0] }
          if (obj.orderID) {
            sale.e_SalesOrderID = obj.orderID
            sale.products &&
              sale.products.length > 0 &&
              sale.products.map(we => {
                we.e_SalesOrderID = obj.orderID
              })
          } else if (obj.receipt_code) {
            sale.receiptCode = obj.receipt_code
          }
          await saveEntitiesDatatoIndexBD(
            [sale],
            INDEX_DB_NAME,
            CURRENT_VERSION,
            INDEX_DB_TABLES.SALES,
            'updateSaleIndexed'
          )
          console.log('Updated Index Successfully for sale')
        }
      }
    })
    .catch(e => {
      console.log('INDEX_DB_ERROR -> updateSaleIndexed -->', e)
    })
}

export function apploggedInResp (
  response,
  dispatch,
  history,
  outRegEnabled,
  isFromApp,
  isSwitch,
  dataInfo
) {
  dispatch({
    type: SIGNIN_USER,
    payload: {
      token: response.data.data.token,
      x1Auth_SHA: response.data.data.x1Auth_SHA,
      x1Auth_SHB: response.data.data.x1Auth_SHB,
      subscriptionExpiresOn: response.data.data.subscriptionExpiresOn,
      storeCommonConfigurations: response.data.data.storeCommonConfigurations,
      value: true
    }
  })
  localStorage.setItem('token', response.data.data.token)
  localStorage.setItem('x1AUTH_SHA', response.data.data.x1Auth_SHA)
  localStorage.setItem('x1AUTH_SHB', response.data.data.x1Auth_SHB)
  localStorage.setItem(
    'subscriptionExpiresOn',
    response.data.data.subscriptionExpiresOn
  )
  // localStorage.setItem(
  //   "storageCommonConfigurations",
  //   JSON.stringify(response.data.data.storeCommonConfigurations)
  // );

  if (response.data.data && response.data.data.profileImageURL) {
    localStorage.setItem('profileImage', response.data.data.profileImageURL)
  }
  if (!isSwitch) {
    if (
      // outRegEnabled &&
      response.data.data &&
      response.data.data.userSelectedOutReg
    ) {
      let selectedData = response.data.data.userSelectedOutReg
      if (
        selectedData.selectedOutlet &&
        selectedData.selectedOutlet.id &&
        selectedData.selectedOutlet.outlet
      ) {
        let body = {
          OutletID: selectedData.selectedOutlet.id
        }

        localStorage.setItem(
          'selectedOut',
          JSON.stringify(selectedData.selectedOutlet)
        )
        dispatch(loadSelectedStoreOutlets(selectedData.selectedOutlet))
        dispatch(loadOutletRegisters(body, true))
      } else {
        localStorage.removeItem('selectedOut')
        dispatch(loadSelectedStoreOutlets({}))
      }

      if (
        selectedData.selectedRegister &&
        selectedData.selectedRegister.id &&
        selectedData.selectedRegister.register
      ) {
        localStorage.setItem(
          'selectedReg',
          JSON.stringify(selectedData.selectedRegister)
        )
        dispatch(loadSelectedOutletRegisters(selectedData.selectedRegister))
      } else {
        localStorage.removeItem('selectedReg')
        dispatch(loadSelectedOutletRegisters({}))
      }
    }
  } else {
    if (dataInfo.outletID || dataInfo.registerID) {
      let postBody = {
        OutletID: dataInfo && dataInfo.outletID ? dataInfo.outletID : '',
        RegisterID: dataInfo && dataInfo.registerID ? dataInfo.registerID : ''
      }
      dispatch(loadUserSelectOutReg(postBody))
    }
  }

  login_redirect(dispatch, history, isFromApp, isSwitch)
  dispatch(loadLoginLoader(false))

  if (isFromApp) {
    postDataToApp(PostAppTypes.LOGIN_DONE, true)
  }
}

export function openRegPop () {
  return dispatch => {
    dispatch(loadIsSelectReg(true))
  }
}

export async function getIndexedSale (key) {
  const data = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
  data
    .then(e => {
      let result = {}
      if (e && e.length > 0) {
        const saleExist = e.filter(q => q.indexKey == key)
        if (saleExist && saleExist.length > 0) {
          result = { ...saleExist[0] }
        }
      }
      return result
    })
    .catch(e => {
      console.log('INDEX_DB_ERROR -> forceUpdateIndexSales -->', e)
      return {}
    })
}

export async function getIndexedConfigData (keyName) {
  const data = GetIndexDBDataByTableName(
    INDEX_DB_NAME,
    INDEX_DB_TABLES.CONFIGDATA
  )
  data
    .then(e => {
      let result = {}
      if (e && e.length > 0) {
        const saleExist = e.filter(q => q.config_key == keyName)
        if (saleExist && saleExist.length > 0) {
          result = { ...saleExist[0] }
        }
      }
      return result
    })
    .catch(e => {
      console.log('INDEX_DB_ERROR -> getIndexedConfigData -->', e)
      return {}
    })
}

export function generateSaleBarcode (storeid, outletid, regid, saleid) {
  let result = false
  if (storeid && outletid && regid && saleid) {
    result = `${storeid}_${outletid}_${regid}_${saleid}`
  }
  return result
}

export function decryptSaleBarcode (info) {
  let result = false
  if (info && isString(info) && info.includes('_')) {
    let obj = info.split('_')
    result = {
      storeid: obj.length > 0 ? obj[0] : '',
      outletid: obj.length > 1 ? obj[1] : '',
      regid: obj.length > 2 ? obj[2] : '',
      saleid: obj.length > 3 ? obj[3] : ''
    }
  }
  return result
}

export function checkIndexedOfflineSales () {
  const data = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
  data
    .then(async e => {
      const curr_index_key = localStorage.getItem('index_key') // current in progress sale should not be send for syncing
      const postBodies = []
      const postIndexKeys = []
      let postSales = []
      let updateIndexedSales = []
      const saleExist =
        e &&
        e.length > 0 &&
        e.filter(
          er =>
            er.isCompleted == true &&
            er.isOffline == true &&
            er.syncInProgress == false &&
            er.isSynced == false &&
            er.isSyncError == false
        )
      const errorSales =
        e &&
        e.length > 0 &&
        e.filter(
          er =>
            er.tryCount < 3 &&
            er.isOffline == true &&
            er.syncInProgress == false &&
            er.isSyncError == true
        )
      const cleanIndexedSales =
        e &&
        e.length > 0 &&
        e.filter(
          er =>
            er.isSynced == true ||
            (er.isOffline == false && er.isCompleted == true)
        )
      const parkedOffline = []
      // e &&
      // e.length > 0 &&
      // e.filter(
      //   er =>
      //     er.isOffline == true &&
      //     er.isParked == true &&
      //     er.isSyncError == false &&
      //     er.syncInProgress == false &&
      //     er.isSynced == false
      // )
      const voidSales =
        e &&
        e.length > 0 &&
        e.filter(
          er =>
            getDecryptID(er.e_SalesOrderStatusID) ==
              getDecryptID(fetchCurrentSalesOrder('Voided')) &&
            er.isOffline == true &&
            //er.syncInProgress == false &&
            er.isSynced == false &&
            er.isSyncError == false
        )
      if (saleExist && saleExist.length > 0) {
        postSales = saleExist.slice(0, OFFSET_SYNC_SALES)
        postSales.map(a => {
          if (a.indexKey != curr_index_key) {
            a.syncInProgress = true
            postBodies.push({
              CreateModel:
                a.createBody && !isEmptyObject(a.createBody)
                  ? JSON.stringify(a.createBody)
                  : '',
              PayModel:
                a.payBodys && a.payBodys.length > 0
                  ? JSON.stringify(a.payBodys)
                  : '',
              CompleteModel:
                a.completeBody && !isEmptyObject(a.completeBody)
                  ? JSON.stringify(a.completeBody)
                  : ''
            })
            postIndexKeys.push(a.indexKey)
          }
        })
      }
      // error sales
      if (errorSales && errorSales.length > 0) {
        let postErrorSales = errorSales.slice(0, OFFSET_SYNC_ERROR_SALES)
        postErrorSales.map(a => {
          if (
            a.returnResp &&
            !isEmptyObject(a.returnResp) &&
            a.returnResp.callTypes &&
            a.returnResp.callTypes.length > 0
          ) {
            a.syncInProgress = true
            a.tryCount = a.tryCount + 1
            postSales.push(a)
            let create_error_body = false
            let pay_error_body = false
            let complete_error_body = false
            const createBody = a.returnResp.callTypes.filter(
              qr =>
                qr.callType == SYNC_CALL_TYPES.CREATE && qr.isSuccess == false
            )
            const payBody = a.returnResp.callTypes.filter(
              qr => qr.callType == SYNC_CALL_TYPES.PAY && qr.isSuccess == false
            )
            const completeBody = a.returnResp.callTypes.filter(
              qr =>
                qr.callType == SYNC_CALL_TYPES.COMPLETE && qr.isSuccess == false
            )
            if (createBody && createBody.length > 0) {
              // CAN GET THE ERROR SEEN HERE WHICH CAME BACK FROM SERVER PREV..
              create_error_body = createBody[0].postBody
                ? createBody[0].postBody
                : false
            }
            if (payBody && payBody.length > 0) {
              // CAN GET THE ERROR SEEN HERE WHICH CAME BACK FROM SERVER PREV..
              const pay_list = payBody.map(ff => {
                if (ff.postBody) {
                  return JSON.parse(ff.postBody)
                }
              })
              pay_error_body =
                pay_list && pay_list.length > 0
                  ? JSON.stringify(pay_list)
                  : false
            }
            if (completeBody && completeBody.length > 0) {
              // CAN GET THE ERROR SEEN HERE WHICH CAME BACK FROM SERVER PREV..
              complete_error_body = completeBody[0].postBody
                ? completeBody[0].postBody
                : false
            }
            postBodies.push({
              CreateModel: create_error_body ? create_error_body : '',
              PayModel: pay_error_body ? pay_error_body : '',
              CompleteModel: complete_error_body ? complete_error_body : ''
            })
            postIndexKeys.push(a.indexKey)
          }
        })
      }
      // parked offline
      if (parkedOffline && parkedOffline.length > 0) {
        let postParkedSales = parkedOffline.slice(0, OFFSET_SYNC_PARKED_SALES)
        postParkedSales.map(a => {
          if (a.indexKey != curr_index_key) {
            a.syncInProgress = true
            postSales.push(a)
            postBodies.push({
              CreateModel:
                a.createBody && !isEmptyObject(a.createBody)
                  ? JSON.stringify(a.createBody)
                  : '',
              PayModel:
                a.payBodys && a.payBodys.length > 0
                  ? JSON.stringify(a.payBodys)
                  : '',
              CompleteModel: ''
              //   a.completeBody && !isEmptyObject(a.completeBody)
              //     ? JSON.stringify(a.completeBody)
              //     : ''
            })
            postIndexKeys.push(a.indexKey)
          }
        })
      }
      if (postSales && postSales.length > 0) {
        postSyncIndexSales(postBodies, postIndexKeys)
        updateIndexedSales = postSales
      }
      if (voidSales && voidSales.length > 0) {
        let void_sales = voidSales.slice(0, OFFSET_SYNC_SALES)
        const body = void_sales.map(qs => {
          qs.syncInProgress = true
          updateIndexedSales.push(qs)
          return {
            SalesOrderID: qs.e_SalesOrderID,
            IndexKey: qs.indexKey
          }
        })
        postVoidSale(body)
      }

      if (updateIndexedSales && updateIndexedSales.length > 0) {
        await saveEntitiesDatatoIndexBD(
          updateIndexedSales,
          INDEX_DB_NAME,
          CURRENT_VERSION,
          INDEX_DB_TABLES.SALES,
          'checkIndexedOfflineSales'
        )
      }

      // for removing synced sales and online completed sales
      if (cleanIndexedSales && cleanIndexedSales.length > 0) {
        await removeEntitiesDatatoIndexBD(
          cleanIndexedSales,
          INDEX_DB_NAME,
          CURRENT_VERSION,
          INDEX_DB_TABLES.SALES
        )
      }
    })
    .catch(e => {
      console.error('SYNC_INDEX_DB_ERROR -> checkIndexedOfflineSales -->', e)
    })
}

async function postSyncIndexSales (sales, keys) {
  const createReq = ds.postSyncSalesService(sales)
  await createReq
    .then(res => {
      if (res && res.length > 0) {
        const returnedList = []
        res.map(ww => {
          if (ww.indexKey) {
            returnedList.push(ww)
          }
        })
        if (returnedList && returnedList.length > 0) {
          syncRespSave(returnedList)
        }
      }
    })
    .catch(e => {
      console.log('SYNC_INDEX_DB -> postSyncIndexSales -->', e)
      if (keys && keys.length > 0) handleIndexErrorHolders(keys)
    })
}

function syncRespSave (list) {
  const data = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
  data
    .then(async e => {
      const saleExist = e.filter(q => list.some(a => a.indexKey == q.indexKey))
      if (saleExist && saleExist.length > 0) {
        let index_sales = [...saleExist]
        index_sales.map(rr => {
          const resp =
            list.filter(o => o.indexKey == rr.indexKey).length > 0
              ? list.filter(o => o.indexKey == rr.indexKey)[0]
              : {}
          if (resp && !isEmptyObject(resp)) {
            if (resp.hasError) {
              rr.isSyncError = true
            } else {
              rr.isSyncError = false
              rr.isSynced = true
            }
            rr.returnResp = resp
            rr.syncInProgress = false
            rr.inProgress = false
          }
        })
        await saveEntitiesDatatoIndexBD(
          index_sales,
          INDEX_DB_NAME,
          CURRENT_VERSION,
          INDEX_DB_TABLES.SALES,
          'syncRespSave'
        )
      }
    })
    .catch(e => {
      console.error('SYNC_INDEX_DB_ERROR -> syncRespSave -->', e)
    })
}

function handleIndexErrorHolders (keys) {
  const data = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
  data
    .then(async e => {
      const saleExist = e.filter(q => keys.some(a => a == q.indexKey))
      if (saleExist && saleExist.length > 0) {
        let index_error_sales = [...saleExist]
        index_error_sales.map(rr => {
          rr.syncInProgress = false
        })
        await saveEntitiesDatatoIndexBD(
          index_error_sales,
          INDEX_DB_NAME,
          CURRENT_VERSION,
          INDEX_DB_TABLES.SALES,
          'handleIndexErrorHolders'
        )
      }
    })
    .catch(e => {
      console.error('SYNC_INDEX_DB_ERROR -> handleIndexErrorHolders -->', e)
    })
}

export async function forceUpdateIndexSales (key) {
  const data = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
  data
    .then(async e => {
      const saleExist = key ? e.filter(q => q.indexKey == key) : e
      if (saleExist && saleExist.length > 0) {
        if (key) {
          let sale = { ...saleExist[0] }
          sale.syncInProgress = false
          await saveEntitiesDatatoIndexBD(
            [sale],
            INDEX_DB_NAME,
            CURRENT_VERSION,
            INDEX_DB_TABLES.SALES,
            'forceUpdateIndexSales'
          )
        } else {
          let sale = [...saleExist]
          sale.map(a => {
            a.syncInProgress = false
          })
          await saveEntitiesDatatoIndexBD(
            sale,
            INDEX_DB_NAME,
            CURRENT_VERSION,
            INDEX_DB_TABLES.SALES,
            'forceUpdateIndexSales'
          )
        }
        console.log('Updated Index Successfully for sale')
      }
    })
    .catch(e => {
      console.log('INDEX_DB_ERROR -> forceUpdateIndexSales -->', e)
    })
}

export function discardHelperFn (
  orderID,
  getCurrentSalesOrderStatusID,
  parentSalesOrderID,
  isParent,
  isPark,
  getSelectedReg,
  getSelectedOutlet,
  saleInfo,
  getDeletedProds,
  form,
  isDiscardSale,
  dispatch
) {
  if (
    (orderID && orderID != '' && getCurrentSalesOrderStatusID != '') ||
    isParent
  ) {
    let verified = true
    let body = {
      BehaviorName: 2,
      SalesOrderID: orderID,
      SalesOrderStatusID: getCurrentSalesOrderStatusID,
      ParentSalesOrderID:
        parentSalesOrderID && parentSalesOrderID != '' ? parentSalesOrderID : ''
    }

    if (isParent || isPark) {
      saleInfo.E_RegisterID = getSelectedReg
      saleInfo.E_OutletID = getSelectedOutlet
      const cashRegPay = localStorage.getItem('cashManageID')
      if (cashRegPay && cashRegPay != '') {
        saleInfo.E_SalesOrderStatusID = fetchCurrentSalesOrder('Voided')
        saleInfo.CashRegPaymentID = cashRegPay
        saleInfo.DeletedProds = getDeletedProds ? getDeletedProds : []
        body.IsPost = true
        body.SaleInfo = saleInfo
      } else {
        verified = false
        clearAllSale(form, dispatch, false)
      }
    }
    if (verified) {
      dispatch(loadIsDiscardSale(false))
      dispatch(loadPostMainSaleDeleteDataService(body))
    }
  } else {
    clearAllSale(form, dispatch, isDiscardSale === '1')
    // dispatch(loadRefundSaleStatus(0)); //Refund Sale Status --->  0 = Not Refund, 1 = Refund Allow, 2 = Already Refunded
  }
}

export function checkIndexedParkedSale (
  orderID,
  getCurrentSalesOrderStatusID,
  parentSalesOrderID,
  isParent,
  isPark,
  getSelectedReg,
  getSelectedOutlet,
  saleInfo,
  getDeletedProds,
  form,
  isDiscardSale,
  dispatch
) {
  const data = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
  data
    .then(async e => {
      if (e && e.length > 0) {
        let parkedSale = e.filter(q =>
          q.indexKey == saleInfo.indexKey ? saleInfo.indexKey : 0
        )
        if (parkedSale && parkedSale.length > 0 && parkedSale[0].isOffline) {
          // parkedSale[0].isCompleted = true
          parkedSale[0].inProgress = false
          parkedSale[0].isParked = false
          parkedSale[0].e_SalesOrderStatusID = fetchCurrentSalesOrder('Voided')
          await saveEntitiesDatatoIndexBD(
            [parkedSale[0]],
            INDEX_DB_NAME,
            CURRENT_VERSION,
            INDEX_DB_TABLES.SALES,
            'checkIndexedParkedSale'
          )
          clearAllSale(false, dispatch, false)
        } else {
          discardHelperFn(
            orderID,
            getCurrentSalesOrderStatusID,
            parentSalesOrderID,
            isParent,
            isPark,
            getSelectedReg,
            getSelectedOutlet,
            saleInfo,
            getDeletedProds,
            form,
            isDiscardSale,
            dispatch
          )
        }
      } else {
        discardHelperFn(
          orderID,
          getCurrentSalesOrderStatusID,
          parentSalesOrderID,
          isParent,
          isPark,
          getSelectedReg,
          getSelectedOutlet,
          saleInfo,
          getDeletedProds,
          form,
          isDiscardSale,
          dispatch
        )
      }
    })
    .catch(e => {
      discardHelperFn(
        orderID,
        getCurrentSalesOrderStatusID,
        parentSalesOrderID,
        isParent,
        isPark,
        getSelectedReg,
        getSelectedOutlet,
        saleInfo,
        getDeletedProds,
        form,
        isDiscardSale,
        dispatch
      )
      console.log(
        'INDEX_DB_ERROR -> checkIndexedParkedSale, attribute parked offline sale -->',
        e
      )
    })
}

async function postVoidSale (body) {
  const postVoid = ds.postVoidSaleService(body, BEHAVIOUR_TYPE.UPDATE)
  await postVoid
    .then(res => {
      const to_remove = []
      if (res && res.msg.includes('Voided')) {
        if (res.list && res.list.length > 0) {
          const returnedList = []
          res.list.map(ww => {
            if (ww.indexKey) {
              returnedList.push(ww)
            }
          })
          if (returnedList && returnedList.length > 0) {
            syncRespSave(returnedList)
          }
        }
      }

      body &&
        body.length > 0 &&
        body.map(io => {
          if (res.list && res.list.length > 0) {
            const ifExist = res.list.filter(w => w.indexKey == io.IndexKey)
            if (ifExist.length == 0) {
              to_remove.push(io.IndexKey)
            }
          } else {
            to_remove.push(io.IndexKey)
          }
        })

      if (to_remove && to_remove.length > 0) {
        clearIndexedDiscarded(to_remove)
      }
    })
    .catch(e => {
      console.log('error: postVoidSale -->', e)
    })
}

export const clearIndexedDiscarded = list => {
  const inProgressedSales = GetIndexDBDataByTableName(
    INDEX_DB_NAME,
    INDEX_DB_TABLES.SALES
  )
  inProgressedSales
    .then(e => {
      if (e && e.length > 0 && list && list.length > 0) {
        const saleArray = []
        list.map(ff => {
          const sale = e.filter(er => er.indexKey == ff)
          if (sale && sale.length > 0) {
            saleArray.push(sale[0])
          }
        })
        removeEntitiesDatatoIndexBD(
          saleArray,
          INDEX_DB_NAME,
          CURRENT_VERSION,
          INDEX_DB_TABLES.SALES
        )
      }
    })
    .catch(e => {
      console.log('INDEX_DB -> clearIndexedDiscarded -->', e)
    })
}

export async function updateProductIndexed (obj) {
  const data = GetIndexDBDataByTableName(
    INDEX_DB_NAME,
    INDEX_DB_TABLES.PRODUCTS
  )
  data
    .then(async e => {
      if (obj && !isEmptyObject(obj)) {
        const productExist = e.filter(q => q.productID == obj.key)
        if (productExist && productExist.length > 0) {
          let prodList = [...productExist]
          prodList.map(ppp => {
            ppp.isActive = obj.isActive == true ? true : false
          })
          await saveEntitiesDatatoIndexBD(
            prodList,
            INDEX_DB_NAME,
            CURRENT_VERSION,
            INDEX_DB_TABLES.PRODUCTS,
            'updateProductIndexed'
          )
          console.log('Updated Index Successfully for product')
        }
      }
    })
    .catch(e => {
      console.log('INDEX_DB_ERROR -> updateProductIndexed -->', e)
    })
}

export async function updateExistingProds (
  res,
  getCurrentSalesOrderData,
  body,
  buildProds,
  salesOrderID
) {
  if (res.items && res.items.length > 0) {
    res.items.map(qq => {
      if (
        getCurrentSalesOrderData.Products &&
        getCurrentSalesOrderData.Products.length > 0
      ) {
        getCurrentSalesOrderData.Products.map(rr => {
          rr.E_SalesOrderID = salesOrderID
          if (rr.key == qq.key) {
            rr.E_SalesOrderItemID = qq.itemKey
            rr.BehaviorName = 3
          }
        })
      }

      if (body.Products && body.Products.length > 0) {
        body.Products.map(rr => {
          rr.E_SalesOrderID = salesOrderID
          if (rr.key == qq.key) {
            rr.E_SalesOrderItemID = qq.itemKey
            rr.BehaviorName = 3
          }
        })
      }

      if (buildProds && buildProds.length > 0) {
        buildProds.map(er => {
          er.sSalesOrderID = salesOrderID
          if (er.key == qq.key) {
            er.sSalesOrderItemID = qq.itemKey
          }
        })
      }
    })
  }
}

export async function updateExistingTaxes (
  res,
  getCurrentSalesOrderData,
  body,
  buildProds
) {
  if (res.itemTaxes && res.itemTaxes.length > 0) {
    res.itemTaxes.map(qq => {
      if (buildProds && buildProds.length > 0) {
        buildProds.map(er => {
          if (er && er.taxComponents && er.taxComponents.length > 0) {
            er.taxComponents.map(ffd => {
              if (ffd.indexKey == qq.key && !ffd.e_SalesOrderItemTaxID) {
                // e_salesOrderItemTaxID
                ffd.e_SalesOrderItemTaxID = qq.itemKey // e_salesOrderItemTaxID
              }
            })
          }
        })
      }

      if (!isEmptyObject(getCurrentSalesOrderData)) {
        if (
          getCurrentSalesOrderData.Products &&
          getCurrentSalesOrderData.Products.length > 0
        ) {
          getCurrentSalesOrderData.Products.map(er => {
            if (er && er.TaxComponents && er.TaxComponents.length > 0) {
              er.TaxComponents.map(ffd => {
                if (ffd.indexKey == qq.key && !ffd.E_SalesOrderItemTaxID) {
                  // E_salesOrderItemTaxID
                  ffd.E_SalesOrderItemTaxID = qq.itemKey // E_salesOrderItemTaxID
                }
              })
            }
          })
        }
      }

      if (body.Products && body.Products.length > 0) {
        body.Products.map(er => {
          if (er && er.TaxComponents && er.TaxComponents.length > 0) {
            er.TaxComponents.map(ffd => {
              if (ffd.indexKey == qq.key && !ffd.E_SalesOrderItemTaxID) {
                // E_salesOrderItemTaxID
                ffd.E_SalesOrderItemTaxID = qq.itemKey // E_salesOrderItemTaxID
              }
            })
          }
        })
      }
    })
  }
}

export function settleRegChecks (
  dispatch,
  getReduxSelectedOutletReg,
  isOnline,
  getReduxOpenListingDataLoad,
  getReduxCashListingDataLoading
) {
  let localRegID =
    localStorage.getItem('selectedReg') != ''
      ? JSON.parse(localStorage.getItem('selectedReg'))
      : false
  let regID =
    getReduxSelectedOutletReg && getReduxSelectedOutletReg.id
      ? getReduxSelectedOutletReg.id
      : localRegID && localRegID.id
      ? localRegID.id
      : false
  if (regID) {
    dispatch(loadCashListingLoading(true))
    dispatch(loadIsRegistorLoading(true))
    let body = {
      registerID: regID
    }
    if (isOnline)
      getCheckRegisterOpen(
        dispatch,
        body,
        getReduxOpenListingDataLoad,
        getReduxCashListingDataLoading,
        isOnline
      )
    else
      checkRegFromIndex(
        dispatch,
        getReduxOpenListingDataLoad,
        getReduxCashListingDataLoading,
        isOnline
      )
  } else {
    dispatch(loadIsRegistorLoading(false))
    dispatch(loadCashListingLoading(false))
  }
}

function checkRegFromIndex (
  dispatch,
  getReduxOpenListingDataLoad,
  getReduxCashListingDataLoading,
  isOnline
) {
  const data = GetIndexDBDataByTableName(
    INDEX_DB_NAME,
    INDEX_DB_TABLES.CONFIGDATA
  )
  data
    .then(e => {
      if (e && e.length > 0) {
        const dataExist = e.filter(er => er.config_key == CONFIG_LOGS.REG_OPEN)
        if (dataExist && dataExist.length > 0) {
          processCheckReg(
            dispatch,
            dataExist[0],
            getReduxOpenListingDataLoad,
            getReduxCashListingDataLoading,
            isOnline,
            'checkRegFromIndex'
          )
        }
      } else {
        console.error(
          'INDEX_DB_DATA_NOT_FOUND -> INDEX_DB_TABLES.CONFIGDATA -->',
          e
        )
      }
    })
    .catch(e => {
      console.error('INDEX_DB_CONFIGS_ERROR -> checkRegFromIndex -->', e)
    })
}

function processCheckReg (
  dispatch,
  res,
  getReduxOpenListingDataLoad,
  getReduxCashListingDataLoading,
  isOnline,
  from
) {
  try {
    if (res.extraPrinters) {
      localStorage.setItem('extraPrints', '1')
    } else {
      localStorage.setItem('extraPrints', '0')
    }
    if (res.isOpen) {
      let id = res.id

      //if day past since opening reg
      if (res.isTimeExceed && isOnline) {
        dispatch(loadIsDayPast(true))
      }

      //calling regInfo to display in open/close with already present check!!!
      let localSavedCashID =
        localStorage.getItem('cashManageID') &&
        localStorage.getItem('cashManageID') != ''
          ? localStorage.getItem('cashManageID')
          : false
      localSavedCashID =
        localSavedCashID && localSavedCashID.includes('&')
          ? localSavedCashID.substring(0, localSavedCashID.indexOf('&'))
          : false
      if (
        !localStorage.getItem('cashManageID') ||
        localStorage.getItem('cashManageID') == '' ||
        (localSavedCashID &&
          localSavedCashID != id.substring(0, id.indexOf('&')))
      ) {
        let body = {
          CashManagementID: id
        }
        dispatch(loadClosedRegData(body, false))
      }
      localStorage.setItem('cashManageID', id)
      dispatch(loadIsRegistorOpen(true))
      dispatch(loadIsRegistorLoading(false))
      // dispatch(loadIsRegistorLoading(false));
      dispatch(loadCashListingLoading(false))
      if (!window.location.pathname.includes('/openclose/listing')) {
        dispatch(loadOpenCloseListingDataLoad(!getReduxOpenListingDataLoad)) //to load data in Open/Close -> OpenListing
      }

      // call for open/close cash Component
      let bodyForComp = {
        CMID: id,
        OutID: '',
        IsClosed: false
      }
      dispatch(loadOpenClosePaySummary(bodyForComp))

      dispatch(loadCashListingDataLoading(!getReduxCashListingDataLoading))
    } else {
      dispatch(loadIsRegistorOpen(false))
      dispatch(loadIsRegistorLoading(false))
      // dispatch(loadIsRegistorLoading(false));
      dispatch(loadCashListingLoading(false))
      localStorage.setItem('cashManageID', '')
    }
  } catch (e) {
    console.error(
      `SETUP_INDEX_DB_CONFIGS_ERROR -> processCheckReg_from_${from} -->`,
      e
    )
  }
}

async function getCheckRegisterOpen (
  dispatch,
  body,
  getReduxOpenListingDataLoad,
  getReduxCashListingDataLoading,
  isOnline
) {
  const getRegister = ds.getRegisterInfoService(body)
  await getRegister
    .then(async res => {
      if (res) {
        processCheckReg(
          dispatch,
          res,
          getReduxOpenListingDataLoad,
          getReduxCashListingDataLoading,
          isOnline,
          'ds.getRegisterInfoService'
        )
        let data_body = { ...res }
        data_body.config_key = CONFIG_LOGS.REG_OPEN
        await saveEntitiesDatatoIndexBD(
          [data_body],
          INDEX_DB_NAME,
          CURRENT_VERSION,
          INDEX_DB_TABLES.CONFIGDATA,
          'getCheckRegisterOpen'
        )
      }
    })
    .catch(e => {
      if (!checkUserVerifyPage()) {
        dispatch(loadIsRegistorLoading(false))
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut(store.getState()));
        //   }, 3000);
        // } else {
        //   message.error("Something went wrong...");
        // }
      }
    }) //console.log("CatchAddEditBook", e));
}

export function getSuffixFromStorage (key) {
  let val = ''
  if (localStorage.getItem('selectedReg')) {
    const parseVal = JSON.parse(localStorage.getItem('selectedReg'))
    if (key == 'suff' && parseVal && parseVal.suffix) val = parseVal.suffix
    else if (key == 'pref' && parseVal && parseVal.prefix) val = parseVal.prefix
    else if (key == 'numb' && parseVal && parseVal.number) val = parseVal.number
  }
  return val
}

export function checkUserVerifyPage () {
  return window.location.href.toLowerCase().includes('userverify')
}

export function checkExpiresSub () {
  let result = 0
  const expiresOn = localStorage.getItem('subscriptionExpiresOn')
  if (expiresOn) {
    const subEndsOn = moment(expiresOn)
    const currDate = moment()
    result = dateDiff(currDate, subEndsOn)
  }
  return result ?? 0
}

function dateDiff (first, second) {
  return Math.round((second - first) / (1000 * 60 * 60 * 24))
}

export function filterUserByOutlet (
  userOutlets,
  outletID,
  loggedInUser,
  userID
) {
  let result = false
  const loggedInID = !isEmptyObject(loggedInUser)
    ? getDecryptID(loggedInUser.userID)
    : 0
  if (userOutlets && userOutlets.length > 0) {
    const allowed = userOutlets.some(q => {
      const outID = q.outletID ? getDecryptID(q.outletID) : null
      return outID == '0' || outID == getDecryptID(outletID)
    })
    if (allowed && userID != loggedInID) {
      result = true
    }
  }
  return result
}

export function handleLocalStorage (isFromApp) {
  let local_is_mob_app = ''
  if (isFromApp) local_is_mob_app = localStorage.getItem('is_mob_app')
  const storeName = localStorage.getItem('storeName')
  const storeReq = localStorage.getItem('storeReqNo')
  const storeHash = localStorage.getItem('storeHash')
  localStorage.clear()
  if (isFromApp) localStorage.setItem('is_mob_app', local_is_mob_app)
  localStorage.setItem('storeName', storeName)
  localStorage.setItem('storeHash', storeHash)
  localStorage.setItem('storeReqNo', storeReq)
}

export function formatCurrAmount (curr, amount, spaces, taxCode) {
  const tax_code = taxCode ? ` ${taxCode}` : ''
  let price = amount + tax_code
  let result = ''
  // if (amount && curr) {
  //   while (price.length < spaces) {
  //     price = ' ' + price // Pad with spaces on the left
  //   }
  //   result = curr + price
  // }
  result = curr + ' ' + price
  return result
}

export function verifyPkgFeature (featureID) {
  let result = false
  try {
    const getFeatures = localStorage.getItem('menu')
      ? JSON.parse(localStorage.getItem('menu'))
      : {}
    if (!isEmptyObject(getFeatures) && featureID) {
      const allowedFeatures =
        getFeatures.allowedFeatures && getFeatures.allowedFeatures.length > 0
          ? getFeatures.allowedFeatures
          : []
      if (allowedFeatures && allowedFeatures.length > 0) {
        const isAllowed = allowedFeatures.filter(a => a == featureID)
        if (isAllowed && isAllowed.length > 0) {
          result = true
        }
      }
    }
  } catch (ex) {
    console.log('XXX-subscription-pkg-check-error-XXX', ex)
  }
  return result
}
